import type { Dict } from "./en";

const ptBr: Dict = {
  grid: {
    controls: { group: "Controles de zoom da grade", zoomIn: "Aproximar", zoomOut: "Afastar", fit: "Ajustar a grade à visão" },
    hud: { aria: "HUD de coordenadas da grade", instrument: "Instrumento", xy: "X · Y", zoom: "Zoom", grid: "Grade", chain: "Rede" },
    legend: {
      gridZero: { label: "Grid Zero", desc: "Núcleo central bloqueado" },
      vipCore: { label: "VIP Core", desc: "Anel central premium · vendável" },
      premium: { label: "Premium", desc: "Avenidas e anel interno" },
      reserve: { label: "Reserva", desc: "4 zonas reservadas bloqueadas" },
      standard: { label: "Standard", desc: "Território geral" },
    },
    loading: { initializing: "Inicializando território" },
    mode: { aria: "Modo de interação da grade", select: "Selecionar", selectHint: "Desenhar retângulo", inspect: "Inspecionar", inspectHint: "Clicar nas parcelas", itemAria: "Modo {label} — {hint}" },
    enter3d: { title: "Entrar em 3D", fallbackName: "território" },
    panel: {
      parcelProfileAria: "Perfil da parcela", parcelProfileTitle: "Perfil da parcela", parcel: "Parcela",
      territoryName: "Nome do território", owner: "Proprietário", position: "Posição", size: "Tamanho", slots: "Espaços", zone: "Zona",
      claimBlock: "Bloco de claim", claimTx: "Tx de claim", selectTerritory: "Selecionar território",
      emptySelection: "A célula não tem parcela. Clique em um território próprio para ver o dossiê.",
      emptyDefault: "Clique em uma parcela na grade para ver propriedade, coordenadas e identidade on-chain.",
      contextAria: "Painel de contexto", panelAria: "Painel", closePanel: "Fechar painel", snapshot: "Snapshot",
      titleArtwork: "Obra", titleSelection: "Seleção", titleContext: "Contexto",
      parcelNum: "Parcel #{id}", selectionSize: "{w} × {h} · {slots} slots", drawRectHint: "Desenhe um retângulo na grade",
    },
    context: {
      emptyTitle: "Nenhum território selecionado",
      emptyDesc: "Desenhe um retângulo na grade para visualizar slots, zona, nível de escassez e preço.",
    },
    detail: {
      fetchFailed: "Falha ao buscar detalhes: {error}",
      conflict: "Conflito de invariante de dados nesta célula: {count} parcels se sobrepõem. Seleção suprimida.",
      cellOutside: "Fora da grade ({x}, {y})",
      cellLoadingMap: "Carregando dados do mapa…",
      cellConfirming: "Confirmando célula ({x}, {y})…",
      cellEmpty: "Célula ({x}, {y}): nenhum parcel indexado nesta célula (no bloco {block})",
      cellConfirmError: "Não foi possível confirmar o estado atual da célula.",
      chainMismatch: "Visualizador indisponível por divergência de rede.",
      indexerNotReady: "Indexer não está pronto — ainda sem snapshot.",
      clickHint: "Clique em um parcel para ver os detalhes.",
      zoneClassifying: "Classificando…",
      zoneUnavailable: "Indisponível",
      zoneSaleLocked: "· venda bloqueada",
      zoneMixed: "· zona mista",
    },
    toolbar: {
      territory: "Território",
      scrollToZoom: "role para dar zoom",
      menu: "Menu",
      openNav: "Abrir navegação",
      hideNav: "Ocultar navegação",
      revealAreas: "Mostrar áreas",
      revealAreasAria: "Mostrar as zonas do território",
      zonesUnavailable: "Mapa de zonas indisponível — tentando novamente automaticamente",
      zonesRetry: "Tentar novamente",
      showDragArtwork: "Mostrar e arrastar obra",
      showDragArtworkAria: "Mostrar e arrastar obra",
      showDragArtworkTitle: "Mostre minha obra na grade e arraste-a para outro parcel",
      loading: "Carregando…",
      myTerritories: "Meus territórios",
    },
    status: {
      live: "AO VIVO", cached: "CACHE", chain: "REDE",
      liveTitle: "Ao vivo · sincronizado",
      cachedTitle: "Mostrando o último snapshot conhecido",
      chainTitle: "Divergência de rede — dados do visualizador suprimidos",
    },
    artworkMsg: {
      none: "Você ainda não tem Frozen Artworks.",
      noPlaced: "Nenhuma obra posicionada para mover.",
      connectWallet: "Conecte sua wallet para mover suas obras.",
    },
    slotCount: {
      slots: "slots",
      selectedTitle: "{slots} slots selecionados ({w} × {h})",
    },
    bottomSheet: { aria: "Painel inferior", dragOpen: "Arraste para redimensionar ou recolher", handle: "Alça do painel" },
    stats: {
      networkStatus: "Status da rede", live: "Ao vivo", offline: "Offline", syncing: "Sincronizando", chain: "Rede",
      parcelsClaimed: "Parcelas reivindicadas", onChain: "on-chain", cellsAllocated: "Células alocadas",
      finiteWorld: "{pct}% do mundo finito", indexerHead: "Cabeça do indexador", finalized: "finalizado #{block}",
    },
    capacity: {
      territory: "Território", resolving: "Resolvendo território…", unavailable: "Capacidade do território indisponível",
      area: "Área do território", publishability: "Publicabilidade", publishable: "Publicável",
      notPublishable: "Não publicável · Mínimo {min} u²", gpCapacity: "Capacidade GP", propertyUnits: "Unidades de propriedade",
    },
    artworks: {
      title: "Obras nesta terra", scanning: "Escaneando…",
      empty: "Nenhuma Frozen Artwork foi colocada nesta terra ainda.", untitled: "Obra sem título", view: "Ver →",
    },
    zoomHint: {
      copy: "Dê zoom para explorar The Grid. No zoom máximo, descubra o que os criadores publicaram em cada parcela.",
      controlDesktop: "Rolagem ou trackpad para dar zoom",
      controlMobile: "Pince para dar zoom",
      dontShow: "Não mostrar novamente",
      close: "Fechar",
      enteringParcels: "Você está entrando nas parcelas",
    },
  },
  nav: {
    marketplace: "Marketplace",
    feed: "Feed",
    rent: "RENT",
    overview: "Visão geral",
    about: "O Projeto",
    howItWorks: "Como Funciona",
    explore: "Explorar",
    creators: "Criadores e Marcas",
    creatorsShort: "Criadores",
    territory: "Território",
    profile: "Perfil",
    enterGrid: "Entre na Grid",
    signIn: "Entrar",
    navigate: "Navegar",
    purchaseBadge: "Compra",
    openMenuAria: "Abrir o menu de navegação",
    closeMenuAria: "Fechar o menu de navegação",
    primaryAria: "Principal",
    howItWorksHintAria: "Novo por aqui? Descubra como a THE GRID funciona",
  },
  lang: { ariaLabel: "Idioma", menuLabel: "Escolher idioma" },
  wallet: {
    connect: "Conectar",
    connecting: "Conectando…",
    myTerritories: "Meus territórios",
    sessionDetails: "Detalhes da sessão",
    disconnect: "Desconectar",
  },
  auth: {
    title: "Sessão",
    subtitle: "Base de autenticação por wallet · SIWE + EIP-1271/6492",
    walletLabel: "Wallet",
    sessionLabel: "Sessão",
    connectPrompt: "Conecte uma wallet pela navegação superior para habilitar o login.",
    loading: "Carregando…",
    signedInAs: "Conectado como {wallet}",
    expires: "expira: {date}",
    signOut: "Sair",
    signIn: "Entre com Ethereum",
    chain: "rede: {name} ({id})",
    status: {
      requestingNonce: "Solicitando nonce…",
      requestingSignature: "Solicitando assinatura à wallet…",
      verifying: "Verificando a assinatura…",
      signedIn: "Conectado como {wallet} (caminho: {path})",
      signedOut: "Sessão encerrada",
    },
  },
  home: {
    hero: {
      eyebrow: "// UM MUNDO. POSSIBILIDADES FINITAS.",
      paragraph:
        "Um único território finito de um milhão de células. Explore, reivindique e seja dono on-chain. Cada parcela é cunhada do mesmo registro, alocada uma única vez, para sempre.",
      enterGrid: "Entre na Grid",
      scrollLine1: "Role para",
      scrollLine2: "Explorar",
      scrollAria: "Role para explorar",
    },
    instrument: {
      title: "Instrumento",
      labels: { grid: "GRADE", chain: "REDE", maxZoom: "MAX·Z", auth: "AUTH" },
    },
    callouts: {
      gridZero: { title: "Grid Zero", body: "Núcleo do território" },
      lattice: { title: "Treliça de dados", body: "Limites de zona on-chain" },
      cells: { label: "Células · Finitas" },
    },
    features: [
      { title: "Finito por Design", body: "1.000.000 de células. Nunca mais." },
      { title: "Construído na Base", body: "Território on-chain · hoje na Base Sepolia." },
      { title: "Explorável por Todos", body: "Leia o mapa sem uma wallet." },
      { title: "Propriedade do Wallet", body: "SIWE · EIP-1271 · EIP-6492 verificados." },
    ],
    story: {
      eyebrow: "Nossa História",
      titleLine1: "UMA NOVA ERA",
      titleLine2: "DA",
      titleHighlight: "PROPRIEDADE",
      paragraph:
        "A Grid nasceu de uma ideia simples: um território digital finito por construção, cujos limites vivem no registro — não na página de marketing. O que você possui aqui, a blockchain lembra.",
    },
    roadmap: {
      phaseLabel: "Fase",
      eyebrow: "Linha do tempo",
      phasesLive: "{live} de {total} fases ativas",
      title: "O QUE ESTÁ PRONTO. O QUE VEM.",
      paragraph:
        "Um mapa honesto, lido direto da Base. Fundações e Propriedade estão ativas hoje — reivindique, crie, publique e seja descoberto agora. Agora estamos na fase de acabamento e correções finais; o próximo grande marco é a Mainnet, e aparecerá aqui só quando for o registro, não o texto, a torná-la real.",
      status: { live: "Ativo", next: "Em andamento", later: "Planejado" },
      phases: [
        {
          title: "Fundações",
          items: [
            "Território canônico de 1.000.000 de células na Base",
            "Indexer + reconciler on-chain ativos",
            "Autenticação de wallet SIWE · EIP-1271 · EIP-6492",
            "Exploração pública, sem wallet",
          ],
        },
        {
          title: "Propriedade e Criação",
          items: [
            "Reivindicação de parcelas e pagamento em USDC na Base",
            "Canvas para criadores — links, redes, mídia, templates",
            "Camada voxel 3D opcional",
            "Publicação + descoberta honesta no Explore",
          ],
        },
        {
          title: "Acabamento final",
          items: [
            "Correções de aceitação e acabamento de UX",
            "Cobertura multilíngue completa",
            "Fortalecimento e QA final antes do lançamento",
            "Página de prévia do Parcel RENT · lançamento previsto Q1 2027",
          ],
        },
        {
          title: "Mainnet",
          items: [
            "Implantação na Mainnet (Base)",
            "Ofertas, mercado secundário e atividade",
            "Certificados e verificação de criadores",
            "APIs públicas e extensões",
          ],
        },
      ],
    },
    cta: {
      eyebrow: "Entrar",
      titlePrefix: "ESCOLHA SEU",
      titleHighlight: "TERRITÓRIO",
      paragraph:
        "O mapa que você explorou é público. A propriedade não. Entre com sua wallet para marcar sua posição — o registro vai lembrar dela.",
      exploreGrid: "Explore a Grid",
      signIn: "Entre com Ethereum",
    },
    footer: {
      legalAria: "Jurídico",
      legalToggle: "Jurídico e políticas",
      walletAuth: "Autenticado por wallet",
      territoryData: "Dados do território · lidos on-chain",
    },
    slidedots: {
      aria: "Navegação de seções",
      overview: "Visão geral",
      story: "História",
      territory: "Território",
      roadmap: "Roadmap",
      enter: "Entrar",
    },
  },
  about: {
    eyebrow: "O Manifesto",
    titleLine1: "UM MUNDO",
    titleHighlight: "FINITO.",
    intro:
      "A THE GRID é um único território digital finito de um milhão de células, alocado uma única vez e possuído on-chain. É nisso que acreditamos e o que o produto realmente faz — nada mais, nada inventado.",
    principles: [
      {
        title: "Finito por construção",
        body: "Um território. Um milhão de células. Nunca mais. Aqui a escassez não é uma escolha de marketing — está escrita no contrato e não pode ser inflada.",
      },
      {
        title: "A propriedade vive on-chain",
        body: "Uma parcela é um ativo on-chain na Base. O que você possui é registrado pelo ledger, não por nós. Os limites do seu território são verificáveis, não prometidos.",
      },
      {
        title: "Público por padrão",
        body: "Qualquer um pode ler o mapa — sem wallet, sem cadastro. A descoberta é aberta. A propriedade é a única coisa que exige provar quem você é.",
      },
      {
        title: "Uma tela, não um outdoor",
        body: "Cada território é uma superfície de design real: texto, links, redes, mídia, formas e uma camada 3D opcional, tudo dentro de um orçamento honesto de Grid-Power derivado do seu terreno.",
      },
      {
        title: "Sua identidade, verificada",
        body: "Sign-In With Ethereum com wallets EOA e de smart-contract (EIP-1271 / EIP-6492). Nunca custodiamos suas chaves nem movemos seus fundos.",
      },
      {
        title: "Feito para durar",
        body: "O conteúdo publicado é um snapshot durável, separado do seu rascunho de trabalho. Editar depois nunca quebra o que o público já vê até você republicar.",
      },
    ],
  },
  how: {
    eyebrow: "A Jornada",
    titleLine1: "DO MAPA",
    titleLine2: "À PROPRIEDADE.",
    intro:
      "Seis passos reais, cada um apoiado por um recurso já disponível. Este é o ciclo inteiro — explore, reivindique, projete, publique e seja descoberto.",
    stepLabel: "PASSO {n}",
    toggle: { show: "Como funciona", hide: "Ocultar", aria: "Mostrar uma explicação simples passo a passo" },
    steps: [
      {
        title: "Explore o mapa",
        body: "Abra o Território e percorra a Grid finita de 1000×1000. Dê zoom em qualquer parcela para ver quem possui o quê — sem precisar de wallet.",
        detail: {
          intro: "Olhar ao redor é totalmente grátis e público — sem wallet, sem conta.",
          points: [
            "Abra Território no menu superior para ver o mapa inteiro: uma única grade de 1.000.000 de pequenos quadrados (células).",
            "Arraste para se mover, role para dar zoom. Dê zoom em qualquer área para ver qual terra está ocupada e o que os donos colocaram lá.",
            "Aqui nada pede que você entre — ler o mapa é sempre aberto a todos.",
          ],
        },
      },
      {
        title: "Reivindique sua parcela",
        body: "Desenhe um retângulo em terra livre e reivindique-a na Base. A propriedade é cunhada on-chain — sua posição é registrada pelo ledger, não por nós.",
        detail: {
          intro: "\"Reivindicar\" significa se tornar dono de um retângulo de células livres. A propriedade é escrita na Base, uma blockchain pública.",
          points: [
            "Você vai precisar de uma wallet cripto — um pequeno app gratuito do navegador que prova que é você e aprova as ações.",
            "Hoje a THE GRID roda na Base Sepolia, uma rede de teste, então você usa USDC de teste — não dinheiro real.",
            "No mapa, desenhe um retângulo sobre terra livre e confirme. Sua wallet assina e a parcela é cunhada para você.",
          ],
        },
      },
      {
        title: "Projete seu Canvas",
        body: "Transforme seu território em uma página real: títulos, links, redes, contatos, mídia e formas — ou comece por um dos seis templates premium. Tudo cabe em um orçamento honesto de Grid-Power derivado da área do seu terreno.",
        detail: {
          intro: "Sua parcela é uma página em branco que você controla. Preencha, ou comece por um template pronto.",
          points: [
            "Adicione títulos, links, botões de redes, contatos, imagens, vídeo e formas simples.",
            "Prefere um empurrão inicial? Carregue um dos seis templates premium e ajuste cada detalhe.",
            "Cada parcela tem um orçamento de Grid-Power baseado no tamanho — mais terra deixa você colocar mais. Mantém as páginas honestas e rápidas.",
          ],
        },
      },
      {
        title: "Adicione uma camada 3D (opcional)",
        body: "Dê profundidade ao seu território com uma cena voxel na qual os visitantes podem entrar ao dar zoom. Totalmente opcional — um Canvas plano também é um resultado de primeira.",
        detail: {
          intro: "Sobre a página plana você pode adicionar uma pequena cena 3D feita de blocos (voxels).",
          points: [
            "Os visitantes entram na cena ao dar zoom fundo na sua parcela.",
            "É totalmente opcional — você nunca precisa criar uma.",
            "Um Canvas plano sem 3D é um resultado completo e de primeira.",
          ],
        },
      },
      {
        title: "Publique",
        body: "Publicar tira um snapshot durável do seu rascunho salvo. Continue editando em particular — o público vê exatamente o que você publicou até você republicar.",
        detail: {
          intro: "Publicar cria uma cópia pública do seu trabalho — enquanto seu rascunho privado continua seu para editar.",
          points: [
            "Tira um snapshot durável do seu rascunho salvo e o mostra ao mundo.",
            "Você pode continuar editando em particular; os visitantes continuam vendo a versão publicada.",
            "Nada do que você mudar fica público até você publicar de novo.",
          ],
        },
      },
      {
        title: "Seja descoberto",
        body: "Toda publicação válida e atual aparece no Explore, das mais recentes primeiro — sem pay-to-rank, sem trending falso. Propriedade real, conteúdo real, ordem honesta.",
        detail: {
          intro: "Uma vez publicado, seu território fica listado para todos — de forma automática e justa.",
          points: [
            "Aparece na página Explore, das mais recentes primeiro.",
            "Não se paga para ranquear mais alto e não há \"trending\" falso.",
            "Propriedade real, conteúdo real, ordem honesta.",
          ],
        },
      },
    ],
    before: {
      eyebrow: "Comece aqui",
      title: "Antes de começar",
      intro: "Para olhar ao redor você não precisa de quase nada. Você só precisa de uma wallet quando decide ser dono de terra.",
      items: [
        { title: "Para explorar: nada", body: "Ler o mapa e abrir qualquer página publicada é totalmente público — sem wallet, sem cadastro." },
        { title: "Uma wallet cripto", body: "Para reivindicar e ser dono você precisa de uma wallet: um pequeno app gratuito do navegador que prova que é você. Nunca custodiamos suas chaves nem seus fundos." },
        { title: "Fundos de teste, não dinheiro real", body: "Hoje a THE GRID roda na Base Sepolia, uma rede de teste gratuita. Você usa USDC de teste para testar tudo com segurança." },
        { title: "Alguns minutos", body: "Reivindicar, projetar e publicar levam minutos — não horas." },
      ],
    },
    journey: {
      eyebrow: "Do início ao fim",
      title: "A jornada completa",
      intro: "O ciclo inteiro num relance. Cada passo leva naturalmente ao próximo.",
      optional: "opcional",
      steps: ["Explorar", "Reivindicar", "Projetar", "Camada 3D", "Publicar", "Ser descoberto"],
    },
    draft: {
      eyebrow: "Duas versões",
      title: "Rascunho vs Publicado",
      intro: "Seu trabalho sempre vive em dois lugares. Entender a diferença é todo o truque.",
      draftLabel: "Rascunho",
      draftBody: "Sua cópia de trabalho privada. Só você vê. Edite quanto quiser, quando quiser.",
      publishedLabel: "Publicado",
      publishedBody: "Um snapshot público durável. É o que os visitantes veem. Não muda até você publicar de novo.",
      takeaway: "Editar seu rascunho é sempre seguro — o público continua vendo sua última versão publicada.",
    },
    levels: {
      eyebrow: "Três níveis de zoom",
      title: "Como a THE GRID é vivida",
      intro: "O mesmo território revela mais quanto mais perto você olha.",
      items: [
        { tag: "Zoom afastado", title: "O mapa", body: "Veja todo o território finito de uma vez e onde está cada coisa." },
        { tag: "Zoom aproximado", title: "Uma página", body: "Dê zoom em uma parcela e ela vira uma página real — o Canvas do dono com texto, links e mídia." },
        { tag: "Mais fundo (opcional)", title: "Em 3D", body: "Continue dando zoom em uma parcela com camada 3D e você entra na cena voxel dela." },
      ],
    },
    faq: {
      eyebrow: "Perguntas de iniciante",
      title: "FAQ para iniciantes",
      intro: "Novo na THE GRID ou no Web3? Comece por aqui.",
      items: [
        { q: "Preciso de uma wallet só para olhar?", a: "Não. Explorar o mapa e abrir qualquer página publicada é totalmente público e grátis." },
        { q: "O que é uma \"wallet\"?", a: "Um pequeno app — muitas vezes uma extensão do navegador — que guarda sua identidade on-chain e deixa você aprovar ações. Você mantém o controle; nunca custodiamos suas chaves nem seus fundos." },
        { q: "Isso é dinheiro real?", a: "Hoje não. A THE GRID roda na Base Sepolia, uma rede de teste gratuita, com USDC de teste — para você testar tudo com segurança." },
        { q: "O que são células e parcelas?", a: "A THE GRID é um único mapa de 1.000.000 de pequenos quadrados chamados células. Uma parcela é um retângulo de células que você possui." },
        { q: "Posso mudar minha página depois de publicar?", a: "Sim. Você mantém um rascunho privado e pode editar quando quiser. O público continua vendo sua última versão publicada até você publicar de novo." },
        { q: "O que é Grid-Power?", a: "Um orçamento simples baseado no tamanho da sua terra que limita quanto você pode colocar, mantendo as páginas honestas e rápidas para carregar." },
      ],
    },
  },
  explore: {
    eyebrow: "Descubra",
    titleLine1: "TERRITÓRIOS",
    titleHighlight: "PUBLICADOS.",
    intro:
      "Territórios reais e atualmente ativos na THE GRID — dos mais recentes. Sem pay-to-rank, sem trending inventado, sem contagens falsas. Abra qualquer um para ver sua página pública.",
    error: {
      title: "Não foi possível carregar o diretório público",
      body: "O serviço de descoberta está indisponível no momento. Tente novamente em instantes.",
      retry: "Tentar de novo",
    },
    empty: {
      title: "O mapa está esperando",
      body: "Nenhum território foi publicado ainda. Quando os criadores publicarem seu Canvas, eles aparecerão aqui — dos mais recentes. Você pode ser o primeiro.",
      claim: "Reivindique seu território",
      how: "Como funciona",
    },
    liveOne: "{count} território ativo",
    liveOther: "{count} territórios ativos",
    modulesOne: "{count} módulo",
    modulesOther: "{count} módulos",
    untitled: "Território sem título",
    view: "Ver território",
    badgeMedia: "Mídia",
  },
  creators: {
    eyebrow: "Criadores e Marcas",
    titleLine1: "SEU TERRITÓRIO,",
    titleHighlight: "SEU PALCO.",
    intro:
      "Seja o que for que você faça, há um ponto de partida para isso. Seis templates Canvas premium transformam um território em uma página pronta em minutos — depois você edita cada pixel. Os templates carregam no seu próprio rascunho dentro do editor; nada é publicado até você decidir.",
    sixTemplates: "Seis templates premium",
    useCases: {
      creator: "Para criadores construindo uma marca pessoal — uma identidade marcante, bio e uma única chamada para ação.",
      retail: "Para pequenas lojas e marcas — um cabeçalho sobre uma prateleira de produtos com um caminho claro para comprar.",
      gallery: "Para artistas — a obra lidera, uma declaração discreta acompanha.",
      music: "Para lançamentos e eventos ao vivo — título, data, local e um link direto para ingressos / stream.",
      product: "Para lançamentos — manchete, linha de apoio, três blocos de recursos e uma CTA.",
      minimal: "Para o minimalismo de alto padrão — contenção, espaço em branco e uma única ação pensada.",
    },
    noteBefore: "Os templates vivem dentro do editor Canvas para um território que você possui. Abra um território, toque em ",
    noteBold: "Templates",
    noteAfter: ", escolha um ponto de partida — ele preenche seu rascunho, e Salvar / Publicar ficam nas suas mãos.",
    howCta: "Como funciona",
  },
  rent: {
    eyebrow: "Recurso planejado",
    titleLine1: "PARCEL",
    titleHighlight: "RENT",
    intro: "Uma forma planejada para que os donos de territórios aluguem apenas parte do seu território para marcas em campanhas promocionais temporárias — mantendo a propriedade total da sua parcela.",
    release: "Lançamento previsto: Q1 2027",
    status: "Ainda não disponível · Prévia informativa",
    coexist: {
      eyebrow: "Território compartilhado",
      title: "Um território. Duas áreas separadas.",
      body: "O dono mantém seu próprio espaço e identidade. A campanha de um patrocinador ficaria apenas dentro da área alugada, por tempo limitado — as duas coexistem lado a lado, sem nunca se misturar.",
      ownerLabel: "Dono",
      sponsorLabel: "Patrocinador",
      ownerLegend: "Área do dono — continua com o dono",
      sponsorLegend: "Área do patrocinador — alugada, por tempo limitado",
      caption: "Exemplo ilustrativo — não é um território nem uma campanha reais",
    },
    how: {
      eyebrow: "Como deve funcionar",
      steps: [
        { title: "A propriedade permanece", body: "A parcela e seu NFT nunca mudam de dono durante um aluguel." },
        { title: "Só uma parte é alugada", body: "O dono escolhe qual área oferecer; o resto do território permanece intacto." },
        { title: "Campanhas temporárias", body: "Um patrocinador só poderia publicar dentro da área aprovada, e o acesso termina quando o aluguel expira." },
        { title: "Verificado e oficial", body: "Verificações de identidade previstas para os participantes do RENT e pagamentos pelo fluxo oficial de aluguel da The Grid." },
      ],
    },
    model: {
      eyebrow: "Modelo de negócio proposto",
      title: "Renda de aluguel para os donos. Uma comissão para a The Grid.",
      body: "No modelo proposto, o dono do território poderá obter renda com a área alugada, enquanto a The Grid receberia uma comissão em cada transação oficial de aluguel.",
      cards: [
        { title: "Donos", body: "Possível renda de aluguel com parte de um território, sem vender a parcela." },
        { title: "Marcas", body: "Uma presença promocional temporária dentro de territórios de criadores selecionados." },
        { title: "The Grid", body: "Uma comissão sobre as transações oficiais de aluguel." },
      ],
      note: "Os níveis de comissão, preços e condições de aluguel ainda não foram definidos.",
    },
    disclaimer: "Parcel RENT é um recurso planejado e não está disponível no momento. Hoje não é possível reservar, pagar ou alugar. Detalhes, elegibilidade, preços e prazo de lançamento podem mudar; não há garantia de ganhos, tráfego ou resultados.",
  },
  shellCta: {
    title: "O mapa é público. A propriedade não.",
    body: "Explore livremente cada território publicado. Quando estiver pronto para reivindicar uma posição, entre com sua wallet — o registro vai lembrar dela.",
    explore: "Explorar territórios",
    enterGrid: "Entre na Grid",
  },
  onboarding: {
    profileEntry: { eyebrow: "Configuração guiada" },
    eyebrow: "Configuração guiada",
    title: "Lance seu território",
    intro: "Um caminho guiado do zero a um território publicado. Nada é obrigatório — saia quando quiser e retome de onde parou. Cada passo leva você à ferramenta real, e seu progresso é salvo.",
    authRequired: {
      title: "Entre para começar o guia",
      body: "A configuração guiada está ligada à sua wallet para salvar seu progresso. Conectar uma wallet não basta — é preciso uma sessão assinada.",
      cta: "Entrar com Ethereum",
    },
    loading: "Carregando seu guia…",
    error: {
      title: "Não foi possível carregar seu guia",
      body: "O serviço de guia está indisponível agora. Tente novamente em breve.",
      retry: "Tentar de novo",
    },
    progress: {
      label: "Passo {n} de {total}",
      complete: "{done} de {total} feitos",
      statusDone: "Feito",
      statusNow: "Agora",
      statusNext: "Próximo",
      statusLocked: "Depois",
    },
    restart: "Recomeçar o guia",
    restartConfirm: "Recomeçar o guia? Isso redefine apenas seu progresso guiado — seus territórios, rascunhos e publicações nunca são tocados.",
    ownershipLost: "O território que você selecionou não pertence mais a esta wallet. Levamos você de volta à seleção de território.",
    actions: {
      select: "Selecionar",
    },
    personas: {
      selected: "Selecionado",
      creator: {
        label: "Criador",
        desc: "Uma marca pessoal, portfólio ou uma identidade única e marcante com uma chamada para ação clara.",
      },
      retail: {
        label: "Negócio / Varejo",
        desc: "Uma loja, produto ou marca — um cabeçalho claro sobre o que você oferece e um caminho para agir.",
      },
    },
    steps: {
      persona: {
        title: "Quem é você?",
        body: "Diga se você é um Criador ou um Negócio. Ajustamos os pontos de partida — você pode mudar isso a qualquer momento.",
      },
      territory: {
        title: "Consiga seu território",
        body: "Possua uma parte da Grid, depois escolha qual território este guia vai construir.",
        pick: "Escolha o território a construir",
        selectedLabel: "Construindo",
        needLand: "Você ainda não possui terreno. Reivindique um parcel na Grid para começar.",
        getLand: "Consiga terreno na Grid",
        nameIt: "Dê um nome a este território",
        loading: "Resolvendo seus territórios…",
        unavailable: "Seus dados de propriedade não puderam ser resolvidos agora. Tente novamente em breve.",
      },
      start: {
        title: "Escolha como começar",
        body: "Comece com um Canvas em branco, ou carregue um dos seis templates premium e torne-o seu. Ambos abrem o editor real — nada é publicado até você decidir.",
        blank: "Começar do zero",
        template: "Usar um template",
        hint: "Os templates vivem dentro do editor em \"Templates\".",
      },
      build: {
        title: "Construa seu território",
        body: "Projete seu Canvas: identidade, mídia, links e contatos. Salve seu rascunho quando gostar — ele fica privado até você publicar.",
        open: "Abrir o editor Canvas",
        draftSaved: "Rascunho salvo",
        noDraft: "Nenhum rascunho salvo ainda",
      },
      publish: {
        title: "Publicar",
        body: "Publicar cria um snapshot público e duradouro do seu rascunho salvo. Você pode continuar editando em privado; o público vê a versão publicada até você republicar.",
        open: "Abrir publicação",
        published: "Publicado",
        notReady: "Salve primeiro um rascunho, depois publique do seu território.",
      },
      launch: {
        title: "Lance e cresça",
        body: "Seu território está no ar. Compartilhe — ele aparece no Explore automaticamente, do mais novo, sem pagar por posição.",
        viewPublic: "Ver sua página pública",
        explore: "Ver no Explore",
        copyLink: "Copiar link público",
        copied: "Link copiado",
        locked: "Publique seu território para desbloquear este passo.",
      },
    },
    guide: {
      title: "Configuração guiada",
      heading: "Construa seu território",
      intro: "Adicione sua identidade, visuais e links, depois salve seu rascunho.",
      items: {
        identity: "Adicione sua identidade (título, slogan)",
        media: "Adicione um visual ou mídia",
        social: "Adicione info social / contato",
        save: "Salvar rascunho",
      },
      back: "Voltar ao guia",
      hide: "Ocultar guia",
    },
    entry: {
      eyebrow: "Novo por aqui?",
      title: "Vamos lançar seu primeiro território",
      body: "Um breve caminho guiado leva você de reivindicar terreno a uma página publicada. Nada é obrigatório.",
      start: "Começar o guia",
      notNow: "Agora não",
      resume: "Retomar o guia",
      restart: "Recomeçar o guia",
      completed: "Guia concluído",
    },
    creatorsCta: {
      title: "Novo no THE GRID? Siga o caminho guiado.",
      body: "De um território seu a uma página publicada em poucos passos guiados — templates, construção, publicação.",
      cta: "Começar a configuração guiada",
    },
  },
  marketplace: {
    home: {
      eyebrow: "The Grid · Marketplace",
      title: "Possua, negocie e colecione as coordenadas de um mundo vivo.",
      subtitle: "Cada anúncio é autoritativo no backend e fail-closed. Parcels de terreno e obras congeladas são liquidados pela mesma autoridade de settlement on-chain — nada é jamais inventado.",
      browseLand: "Explorar Terrenos",
      browseArtworks: "Explorar Obras",
      cardLandTitle: "Terrenos",
      cardLandDesc: "Parcels a preço fixo com pricing autoritativo por zona e floors cross-currency.",
      cardArtworksTitle: "Obras",
      cardArtworksDesc: "Obras congeladas e posicionadas, negociadas com royalties ao criador e leilões ao vivo.",
      cardMineTitle: "Meu Mercado",
      cardMineDesc: "Seus anúncios, ofertas feitas e recebidas e lances de leilão em um só lugar.",
    },
    nav: {
      search: "Buscar",
      searchAria: "Buscar no marketplace",
      notifications: "Notificações",
      notificationsCountAria: "{count} notificações",
    },
    search: {
      title: "Buscar no marketplace",
      subtitle: "Parcels · obras · endereços",
      placeholder: "Parcel #, título da obra ou endereço de wallet…",
      startTyping: "Comece a digitar para buscar anúncios e obras.",
      noMatches: "Nenhum resultado para “{q}”.",
      land: "terreno",
      artwork: "obra",
      sellerPrefix: "Vendedor {addr}",
      byPrefix: "por {addr}",
      auctionSuffix: " · leilão",
    },
    notifications: {
      title: "Notificações",
      offersOne: "{n} oferta para revisar",
      offersMany: "{n} ofertas para revisar",
      offersDetail: "Compradores fizeram ofertas nos seus ativos.",
      outbidOn: "Superado em {title}",
      anAuction: "um leilão",
      topBid: "Maior lance {top} · seu lance {yours}",
      allCaughtUp: "Você está em dia com tudo.",
      markAll: "Marcar tudo como lido",
    },
    land: {
      sectionTitle: "Anúncios de Terreno",
      loadErrorTitle: "Não foi possível carregar os anúncios",
      loadErrorDetail: "O índice do marketplace está inacessível no momento. Nada foi alterado.",
      emptyNoneTitle: "Nenhum terreno anunciado ainda",
      emptyNoneHint: "Quando os proprietários anunciarem parcels à venda, eles aparecerão aqui.",
      emptyFilteredTitle: "Nenhum anúncio corresponde aos seus filtros",
      emptyFilteredHint: "Tente ampliar a faixa de preço ou remover o filtro de zona.",
      slots: "{n} slots",
      filters: {
        zone: "Zona",
        price: "Preço (USDC)",
        min: "Mín",
        max: "Máx",
        minSlots: "Slots mín",
        any: "Qualquer",
        sort: "Ordenar",
        clear: "Limpar filtros",
        sortRecent: "Mais recentes",
        sortPriceAsc: "Preço · do menor ao maior",
        sortPriceDesc: "Preço · do maior ao menor",
        sortSlotsDesc: "Maiores primeiro",
      },
    },
    zones: {
      all: "Todas as zonas",
      standard: "Standard",
      premium: "Premium",
      vip: "VIP",
      reserve: "Reserve",
      gridZero: "Grid Zero",
    },
    artworks: {
      loadErrorTitle: "Não foi possível carregar as obras",
      loadErrorDetail: "O índice da galeria está inacessível no momento.",
      liveAuctions: "Leilões ao Vivo",
      live: "{n} ao vivo",
      gallery: "Galeria",
      works: "{n} obras",
      emptyTitle: "Nenhuma obra ainda",
      emptyHint: "Obras congeladas posicionadas na Grid aparecem aqui para ofertas e leilões.",
      auction: "Leilão",
      openToOffers: "Aberta a ofertas",
      royalty: "{n}% royalty",
      by: "por {addr}",
    },
    detail: {
      backToLand: "Voltar aos Terrenos",
      backToArtworks: "Voltar às Obras",
      listingNotFound: "Anúncio não encontrado",
      listingNotFoundDetail: "Este anúncio pode ter sido vendido ou retirado.",
      artworkNotFound: "Obra não encontrada",
      artworkNotFoundDetail: "Esta obra pode ter sido movida ou removida.",
      loadingParcel: "Carregando parcel…",
      loadingArtwork: "Carregando obra…",
      seller: "Vendedor {addr}",
      creatorOwner: "por {creator} · proprietário {owner}",
      slots: "Slots",
      footprint: "Área",
      floor: "Floor",
      size: "Tamanho",
      cells: "Células",
      royalty: "Royalty",
      status: "Status",
      yourListing: "Seu anúncio",
      buyNow: "Comprar agora",
      unavailable: "Indisponível",
      makeOffer: "Fazer oferta",
      viewOnGrid: "Ver na Grid",
      sellerNote: "Você é o vendedor — compra e ofertas estão desativadas no seu próprio anúncio.",
      ownerNote: "Você possui esta obra — ofertas e lances estão desativados para você.",
      openOffers: "Ofertas Abertas",
      noOffersParcel: "Nenhuma oferta aberta neste parcel.",
      noOffersArtwork: "Nenhuma oferta aberta nesta obra.",
      auctionTag: "Leilão",
      openToOffers: "Aberta a ofertas",
      currentBid: "Lance atual",
      reserve: "Reserva",
      leadingPrefix: "Liderando {addr} · ",
      noBidsYet: "Ainda sem lances · ",
      minNext: "mín próximo {amt} {sym}",
      auctionEnded: "Leilão encerrado",
      yourAuction: "Seu leilão",
      placeBid: "Dar lance",
      buyTitle: "Comprar Parcel #{id}",
      buySubtitle: "Settlement a preço fixo",
      done: "Concluído",
      cancel: "Cancelar",
      reserving: "Reservando…",
      authorizing: "Autorizando…",
      reserveAuthorize: "Reservar e autorizar",
      signInRequired: "Login necessário",
      connectSignIn: "Conecte sua wallet e faça login →",
      settlementUnavailable: "O settlement está temporariamente indisponível — nada pode ser cobrado agora.",
      price: "Preço",
      gridFee: "Taxa Grid",
      settlementAuthorized: "Settlement autorizado",
      settlementAuthorizedBody: "A autoridade de settlement assinou seu permit. Conclua a compra pela sua wallet para finalizar on-chain.",
      authorityFloor: "Autoridade {addr} · floor {amt} {sym}",
      completePurchase: "Complete purchase",
      checkingAllowance: "Checking allowance…",
      confirmInWallet: "Confirm in your wallet…",
      approvingUsdc: "Approving USDC…",
      settlingOnchain: "Finalizing on-chain…",
      purchaseComplete: "Purchase complete",
      purchaseCompleteBody: "The LAND is now yours. Ownership and listings will refresh shortly.",
      buyFailed: "Purchase failed",
      approveRejected: "USDC approval was rejected in your wallet.",
      approveReverted: "The USDC approval transaction reverted on-chain.",
      fillRejected: "The purchase was rejected in your wallet.",
      fillReverted: "The purchase transaction reverted on-chain.",
      wrongBuyerWallet: "Connect the buyer wallet {addr} to complete the purchase.",
      makeOfferTitle: "Fazer uma oferta",
      makeOfferSubtitle: "Oferta vinculante · expiração em market-time",
      submitOffer: "Enviar oferta",
      submitting: "Enviando…",
      amount: "Valor",
      expiresIn: "Expira em",
      dur1h: "1 hora",
      dur24h: "24 horas",
      dur3d: "3 dias",
      dur7d: "7 dias",
      placeBidTitle: "Dar um lance",
      auctionFallback: "Leilão",
      signing: "Assinando…",
      yourBid: "Seu lance ({sym})",
      minNextBid: "Lance mínimo seguinte: {amt} {sym}",
      bidPermitSigned: "Permit de lance assinado",
      bidPermitBody: "A autoridade de settlement assinou seu permit de lance. Envie-o pela sua wallet para registrar o lance on-chain.",
      antiSnipe: " Seu lance cai na janela anti-snipe e estenderá o leilão.",
      authorityMin: "Autoridade {addr} · mín aceito {amt} {sym}",
    },
    provenance: {
      title: "Histórico / Procedência",
      empty: "Ainda não há histórico de propriedade para esta parcela.",
      resale: "Revenda",
      primaryPurchase: "Compra primária",
      privateSale: "Venda privada",
      transfer: "Transferência",
      from: "De",
      to: "Para",
      price: "Preço",
      fee: "Taxa",
      net: "Líquido",
      viewTx: "Ver tx →",
      currentNameLabel: "Nome atual",
    },
    owner: {
      cancelPrivateSale: "Cancelar",
      cancelBlocked: "Não cancelável",
      cancelUnsupportedNote: "O cancelamento on-chain da venda privada não é suportado pelo contrato implantado. As solicitações de cancelamento falham com segurança e nunca modificam o registro.",
      cancelPsTitle: "Cancelar venda privada",
      cancelPsBadge: "Ação do owner",
      cancelPsWarning: "Isto solicita o cancelamento on-chain da venda privada. Só tem efeito após a confirmação da transação on-chain.",
      cancelPsSuccess: "Venda privada cancelada on-chain.",
      cancelPsConfirm: "Solicitar cancelamento",
      cancelPsClose: "Fechar",
      cancelPsUnsupported: "O contrato implantado não suporta o cancelamento on-chain da venda privada. Nenhum registro foi modificado.",
      psStatusActive: "Ativa",
      psStatusCompleted: "Concluída",
      psStatusExpired: "Expirada",
      psStatusCancelled: "Cancelada",
      verifyingAccess: "Verificando acesso de owner…",
      accessDeniedTitle: "Acesso de owner necessário",
      accessDeniedHint: "Este console é restrito às wallets owner na allow-list do servidor. Faça login com uma wallet admin.",
      loadErrorTitle: "Não foi possível carregar a Owner Console",
      loading: "Carregando Owner Console…",
      integrityTitle: "Integridade da Supply",
      noFreeGrant: "Sem grant gratuito ✓",
      grantAnomaly: "Anomalia de grant ✕",
      supplyActiveListings: "Anúncios Ativos",
      supplySoldListings: "Anúncios Vendidos",
      supplyOpenOffers: "Ofertas Abertas",
      supplyOpenAuctions: "Leilões Abertos",
      supplyPendingSettlements: "Settlements Pendentes",
      supplyPaidAcquisitions: "Aquisições Pagas",
      zeroPriceGrants: "Grants a preço zero",
      actionsTitle: "Ações de Owner",
      gridZeroManual: "Grid Zero manual",
      releaseLabel: "Release",
      releaseDesc: "Tornar disponível o inventário elegível. Cell-authoritative: liberadas, não efetivamente reservadas, não ocupadas.",
      relockLabel: "Relock",
      relockDesc: "Rebloquear inventário disponível. Nunca rebloqueia células vendidas, ocupadas ou inelegíveis.",
      privateSaleLabel: "Venda Privada",
      privateSaleDesc: "Criar uma venda voltada a um comprador. O preço de tier é oficial; Grid Zero é manual. O preço deve ser > 0.",
      failClosed: "Fail-closed",
      unavailable: "Indisponível",
      privateSalesTitle: "Vendas Privadas",
      noPrivateSalesTitle: "Nenhuma venda privada projetada",
      noPrivateSalesHint: "As vendas privadas aparecem aqui quando criadas on-chain — canceláveis até o pending.",
      buyer: "comprador {addr}",
      perSlot: "/ slot",
      executed: "Executada",
      pending: "Pendente",
      supplyCheckTitle: "Verificação de Supply",
      walletPlaceholder: "endereço de wallet 0x",
      checking: "Verificando…",
      auditWallet: "Auditar wallet",
      supplyCheckFailed: "Falha na verificação de supply",
      owned: "Em posse",
      paidOrigin: "Origem paga",
      integrity: "Integridade",
      consistent: "Consistente",
      anomalies: "Anomalias",
      confirmationSuffix: "confirmação {tier}",
      tierNormal: "normal",
      tierStrong: "forte",
      tierMaximum: "máxima",
      failClosedBanner: "Fail-closed: {reason}. Esta ação não pode ser executada — nada é cobrado ou inventado.",
      typeToProceedPre: "Digite ",
      typeToProceedPost: " para continuar",
      ack: "Entendo que esta é uma ação de owner cell-authoritative e confirmo o alvo e a quantidade.",
      confirmAction: "Confirmar {action}",
      submitting: "Enviando…",
      cancel: "Cancelar",
      zoneLabel: "Zona",
      slotsLabel: "Slots",
      buyerLabel: "Wallet do comprador",
      priceLabel: "Preço unitário (USDC)",
      priceHintGridZero: "Grid Zero requer um preço unitário manual > 0.",
      priceHintTier: "O preço de tier é oficial e aplicado automaticamente.",
      actionSuccess: "Ação de owner executada",
      actionSuccessBody: "{action}: {count} células em {zone} — registrada no audit de owner imutável. Sem grant gratuito, sem escrita on-chain.",
      demoScope: "Preview Demo — substrate isolado, sem escrita on-chain",
    },
    common: {
      parcelNumber: "Parcel #{id}",
      partialTag: "PARCIAL",
      close: "Fechar",
      retry: "Tentar novamente",
    },
    confirm: {
      normal: "Confirme esta ação de owner cell-authoritative.",
      strong: "Isto afeta {slots} slots (mais de {threshold}). Reinsira a contagem exata de slots para continuar.",
      maximum: "GRID ZERO é o inventário mais sensível da THE GRID. A confirmação máxima é exigida independentemente da quantidade.",
    },
    statePill: {
      active: "ativo",
      sale_pending: "venda pendente",
      confirming: "confirmando",
      sold: "vendido",
      expired: "expirado",
      cancelled: "cancelado",
      reconciliation_required: "reconciliação necessária",
      open: "aberto",
    },
    errors: {
      unauthenticatedTitle: "Login necessário",
      unauthenticatedHint: "Conecte sua wallet e faça login para autorizar esta ação.",
      disabledTitle: "Mercado em pausa",
      disabledHint: "O settlement está temporariamente indisponível. Nada foi cobrado ou alterado — tente novamente quando retomar.",
      cellLockedTitle: "Reservado por outro comprador",
      cellLockedHint: "Uma ou mais células deste parcel estão retidas agora pela compra pendente de outro comprador. Tente novamente em alguns minutos.",
      notActiveTitle: "Não está mais disponível",
      notActiveHint: "Este anúncio não está mais ativo — pode ter acabado de ser vendido ou retirado. Atualize para ver o mais recente.",
      expiredTitle: "Anúncio expirado",
      expiredHint: "Este anúncio expirou e não pode mais ser comprado. O proprietário pode reanunciá-lo.",
      selfTitle: "Este é o seu anúncio",
      selfHint: "Você não pode comprar nem dar lance em um ativo que já está vendendo.",
      belowFloorTitle: "Abaixo do preço floor",
      belowFloorHint: "O preço mudou e agora está abaixo do floor do vendedor. Revise e tente novamente.",
      settlementTitle: "Settlement em andamento",
      settlementHint: "Já há um settlement em andamento para este ativo. Aguarde a finalização antes de tentar novamente.",
      reconciliationTitle: "Reconciliação necessária",
      reconciliationHint: "Este ativo deve ser reconciliado com a chain antes de poder ser negociado. Nenhuma ação foi realizada.",
      spatialTitle: "Conflito de posicionamento",
      spatialHint: "Esta obra não está em um posicionamento liquidável no momento — pode ter se movido ou se sobrepor a outro posicionamento.",
      bidLowTitle: "Lance muito baixo",
      bidLowHint: "Seu lance está abaixo do próximo lance mínimo. Aumente-o e tente novamente.",
      permitReusedTitle: "Permit já usado",
      permitReusedHint: "Esse permit de lance já foi gasto. Dê um lance novo.",
      auctionClosedTitle: "Leilão encerrado",
      auctionClosedHint: "Este leilão não aceita mais lances.",
      auctionNotStartedTitle: "Leilão não iniciado",
      auctionNotStartedHint: "Este leilão ainda não está aberto a lances.",
      sellerBidTitle: "Vendedores não podem dar lance",
      sellerBidHint: "Você não pode dar lance no seu próprio leilão.",
      permitRefusedTitle: "Autorização recusada",
      permitRefusedHint: "A autoridade de settlement recusou assinar. Nenhuma ação foi realizada.",
      noBasisTitle: "Origem não registrada",
      noBasisHint: "Este ativo ainda não tem uma origem de aquisição PAGA registrada, então não pode ser liquidado. Nenhuma ação foi realizada.",
      zeroAmountTitle: "Valor necessário",
      zeroAmountHint: "Insira um valor maior que zero.",
      genericTitle: "Algo deu errado",
      genericHint: "A ação não pôde ser concluída. Nada foi alterado.",
    },
    tabs: {
      overview: "Visão geral",
      land: "Terrenos",
      artworks: "Obras",
      mine: "Meu Mercado",
      owner: "Owner Console",
      ownerAria: "Owner Console — apenas admin",
    },
    states: {
      loading: "Carregando…",
      retry: "Tentar novamente",
      active: "ativos",
    },
    paused: {
      title: "Mercado em pausa",
      body: "O settlement está temporariamente indisponível. A navegação continua aberta; nada pode ser cobrado.",
    },
    mine: {
      signInTitle: "Faça login para ver seu mercado",
      signInHint: "Conecte sua wallet e faça login para ver seus anúncios, ofertas e lances.",
      connectSignIn: "Conectar e entrar →",
      loadErrorTitle: "Não foi possível carregar seu mercado",
      loadingYours: "Carregando seu mercado…",
      listings: "Meus Anúncios",
      listLand: "Vender Terreno",
      noListings: "Nenhum anúncio ativo",
      noListingsHint: "Anuncie um parcel a partir da página de detalhe — ou use Vender Terreno — para vendê-lo.",
      offersReceived: "Ofertas Recebidas",
      offersMade: "Ofertas Feitas",
      bids: "Meus Lances",
      noBids: "Nenhum lance ativo",
      noBidsHint: "Dê um lance em um leilão ao vivo para vê-lo aqui.",
      cancel: "Cancelar",
      withdraw: "Retirar",
      noOpenOffers: "Nenhuma oferta aberta",
      noOffersReceived: "Nenhuma oferta recebida",
      offerMadeHint: "Faça uma oferta a partir de qualquer anúncio ou obra.",
      offerReceivedHint: "As ofertas nos seus ativos aparecerão aqui.",
      accept: "Aceitar",
      decline: "Recusar",
      accepting: "Aceitando…",
      acceptUnsupported: "Este tipo de oferta ainda não pode ser aceito aqui.",
      pendingPurchases: "Compras Pendentes",
      noPendingPurchases: "Nenhuma compra pendente",
      pendingPurchasesHint: "As ofertas que um vendedor aceitou aparecem aqui para concluir a compra.",
      completePurchase: "Concluir compra",
      auction: "Leilão",
      leading: "Liderando",
      outbid: "Superado",
      bidPrefix: "lance",
      artworkLabel: "Obra",
      sales: "Vendas",
      purchases: "Compras",
      noSales: "Nenhuma venda ainda",
      noSalesHint: "As parcelas que você vender no mercado secundário aparecerão aqui.",
      noPurchases: "Nenhuma compra ainda",
      noPurchasesHint: "As parcelas que você comprar no mercado secundário aparecerão aqui.",
      soldTo: "Vendido para",
      boughtFrom: "Comprado de",
      feeShort: "Taxa",
      netShort: "Líquido",
      soldStatus: "Vendido",
      viewTx: "Ver tx →",
    },
    sell: {
      slotsSelected: "Blocos selecionados",
      partialBadge: "Área parcial",
      realSelectTitle: "Selecione a área para vender",
      realSelectHint: "Clique ou arraste para selecionar células. Selecione a parcela inteira para anunciá-la, ou uma área contígua para uma venda parcial.",
      selectWhole: "Selecionar parcela inteira",
      wholeSelectedNote: "Parcela inteira selecionada — a parcela completa será anunciada.",
      wholeIneligibleTitle: "Venda da parcela inteira indisponível",
      wholeIneligibleBody: "Parte desta parcela é inelegível — um bloqueio de mercado ativo ou conteúdo canônico (uma arte posicionada) ocupa uma ou mais células. O anúncio da parcela inteira está bloqueado até que essas células fiquem livres. Nenhum anúncio foi criado.",
      partialDisabledTitle: "Venda parcial indisponível",
      partialVaultRequired: "A venda de uma área parcial requer um token filho on-chain do SubdivisionVault para esta parcela, que ainda não existe. Crie a subdivisão on-chain antes de anunciar esta área. Nenhum anúncio foi criado.",
      subdivisionTooComplex: "A forma selecionada excede o limite de subdivisão on-chain ({total}/{max} retângulos) — ajuste sua seleção. Nenhuma transação foi enviada.",
      subAlreadySubdivided: "Esta parcela já está subdividida on-chain. A re-subdivisão ainda não é suportada.",
      subDepositFailed: "Falha ao depositar a parcela no cofre.",
      subSplitFailed: "Falha na divisão de subdivisão on-chain.",
      subGeometryMismatch: "A geometria do filho on-chain não corresponde à sua seleção.",
      sub_plan: "Calculando subdivisão…",
      sub_approve: "Aprovando cofre…",
      sub_approveCollection: "Aprovando marketplace…",
      nftApprovalFailed: "Falha na aprovação de transferência para o marketplace. Nenhum anúncio foi criado.",
      sub_deposit: "Depositando parcela…",
      sub_split: "Subdividindo on-chain…",
      sub_reconcile: "Reconciliando…",
      sub_sign: "Assinar e anunciar…",
      wholeTitle: "List the whole parcel",
      wholeSubtitle: "Parcel #{id} · whole parcel",
      wholeBadge: "Whole parcel",
      wholeIntro: "You are authorizing a REAL secondary-market listing of the ENTIRE parcel on Base Sepolia. Your wallet signs an EIP-712 order; nothing is written on-chain until a buyer fills it.",
      wholeConnectRequired: "Connect the owner wallet to authorize this listing.",
      wholeOwnerMismatch: "The connected wallet is not the on-chain owner of this parcel.",
      wholeNotConfigured: "The marketplace contract is not configured for real listings.",
      signAndList: "Sign & list",
      signing: "Awaiting wallet signature…",
      reviewToken: "Token ID",
      reviewCollection: "Collection",
      realCreatedTitle: "Listing authorized",
      realCreatedBody: "Your signed order is live in the marketplace. It settles on-chain only when a buyer fills it.",
      partialFutureTitle: "Sell a subset (partial)",
      partialFutureBody: "Partial sale requires an on-chain subdivision-vault child token, which is not yet available on Base Sepolia. Only whole-parcel listings are possible right now.",
      priceRealHelp: "Set your asking price in {sym}.",
      listLand: "Vender Terreno",
      sellLand: "Vender Terreno",
      sellLandDemo: "Vender Terreno · Preview Demo",
      previewDemo: "Preview Demo",
      previewDemoGrid: "Grid Preview Demo",
      myLand: "Meus Terrenos",
      selectLand: "Selecionar Terreno",
      pickTitle: "Escolha o terreno para vender",
      pickHint: "Selecione um dos seus parcels para anunciar um subconjunto contíguo de células.",
      pickEmpty: "Nenhum terreno vendável",
      pickEmptyHint: "Você não possui terreno disponível para venda parcial nesta preview.",
      pickCells: "{n} células",
      pickListed: "{n} ativos",
      pickOpen: "Selecionar área →",
      wizardTitle: "Vender Terreno",
      wizardSubtitle: "Parcel #{id} · Preview Demo",
      stepSelect: "Selecionar área",
      stepPrice: "Preço",
      stepReview: "Revisar",
      selectTitle: "Selecione as células para vender",
      selectHint: "Clique numa célula para alterná-la, ou clique e arraste para pintar um retângulo. A seleção deve ser um bloco contíguo e não pode ser o parcel inteiro.",
      selectedCount: "{n} de {total} células selecionadas",
      clearSelection: "Limpar",
      valLoading: "Validando…",
      valValid: "Seleção válida",
      valInvalid: "Seleção inválida",
      basisLabel: "Custo de aquisição",
      floorLabel: "Floor mínimo de revenda (80%)",
      floorBinding: "Vinculante",
      floorNotBinding: "Floor não vinculante (sem basis registrada)",
      reasonOutside: "As células estão fora do parcel",
      reasonNotContiguous: "As células devem formar um único bloco contíguo",
      reasonFull: "É o parcel inteiro — use o anúncio de parcel completo",
      reasonNotOwner: "Você não é o proprietário deste terreno",
      reasonOverlap: "Algumas células se sobrepõem a um anúncio existente",
      reasonOccupied: "Algumas células estão ocupadas por conteúdo canônico",
      reasonNoBasis: "Piso de revenda indisponível: nenhuma base de custo de aquisição registrada para esta parcela.",
      priceTitle: "Defina seu preço",
      priceLabel: "Preço",
      currencyLabel: "Moeda",
      priceHelpFloor: "Deve ser pelo menos o floor de {floor} {sym}.",
      belowFloor: "O preço está abaixo do floor mínimo de {floor} {sym}.",
      reviewTitle: "Revisar e autorizar",
      reviewCells: "Células",
      reviewArea: "Área",
      reviewFloor: "Floor",
      reviewPrice: "Seu preço",
      authorize: "Autorizar e Publicar",
      authorizeDemo: "Autorizar (Preview Demo) e Publicar",
      creating: "Criando anúncio…",
      createdTitle: "Anúncio demo criado",
      createdBody: "Seu anúncio preview demo já está visível em Meus Anúncios.",
      viewMine: "Ir para Meus Anúncios",
      demoDisclosureTitle: "Preview Demo — sem alteração on-chain / canônica",
      demoDisclosureBody: "Isto anuncia um parcel demo isolado no substrate de preview. Sua sessão SIWE autoriza a escrita; nenhum mint on-chain do SubdivisionVault, nenhuma ordem EIP-712, nenhum settlement na Base Sepolia. Em produção este mesmo fluxo assina com sua wallet e liquida on-chain.",
      back: "Voltar",
      next: "Avançar",
      close: "Fechar",
    },
    artworkMkt: {
      buyNow: "Buy now",
      listedAt: "Listed at",
      fixedPrice: "Fixed price",
      yourListing: "Your listing",
      cancelListing: "Cancel listing",
      sellArtwork: "Sell / List Artwork",
      listArtwork: "List / Sell",
      buyTitle: "Buy “{title}”",
      buySubtitle: "Fixed-price artwork settlement",
      buyIntro: "You are buying this artwork at its listed price. Your wallet locks USDC in escrow, then the sale finalizes on-chain. Nothing moves until you confirm.",
      priceLabel: "Price",
      royaltyLabel: "Creator royalty",
      gridFeeLabel: "Grid fee",
      confirmBuy: "Confirm & buy",
      buyPreparing: "Preparing settlement…",
      buyCheckingAllowance: "Checking USDC allowance…",
      buyApprove: "Approve USDC in your wallet…",
      buyApproving: "Approving USDC…",
      buyOpenWallet: "Confirm escrow in your wallet…",
      buyOpening: "Locking funds in escrow…",
      buyIndexingEscrow: "Confirming escrow on-chain…",
      buyAuthorizing: "Authorizing payout…",
      buyReleaseWallet: "Confirm payout in your wallet…",
      buyReleasing: "Releasing payout on-chain…",
      buyIndexingPayout: "Confirming payout finality…",
      buyFinalizing: "Transferring ownership…",
      buyComplete: "Purchase complete",
      buyCompleteBody: "The artwork is now yours. Ownership and listings refresh shortly.",
      buyRejected: "The action was rejected in your wallet.",
      buyReverted: "The transaction reverted on-chain.",
      buyFailed: "Purchase failed",
      connectBuyer: "Connect the buyer wallet {addr} to complete this purchase.",
      sellIntro: "You own this artwork. List it at a fixed price or open a live auction.",
      cancelListingConfirm: "Cancel this listing?",
      listingCancelled: "Listing cancelled.",
      wizardTitle: "Sell Artwork",
      pickTitle: "Choose an artwork to sell",
      pickHint: "Select a frozen, placed artwork you own that isn't already listed or in auction.",
      pickEmpty: "No sellable artworks",
      pickEmptyHint: "You need a frozen artwork placed on the Grid that isn't already listed or auctioned.",
      chooseMode: "How do you want to sell?",
      modeFixed: "Fixed price",
      modeFixedDesc: "List at a set price. Buyers purchase instantly; you sign nothing on-chain.",
      modeAuction: "Auction",
      modeAuctionDesc: "Run a timed English auction with a reserve. You sign the auction creation on-chain.",
      setPrice: "Set your price",
      priceHint: "Set your asking price in {sym}. Grid fee {fee}% + creator royalty {roy}% are deducted on settlement.",
      listBtn: "List for sale",
      listing: "Listing…",
      listedTitle: "Artwork listed",
      listedBody: "Your artwork is now listed at the fixed price. Buyers can purchase it from its detail page.",
      setAuction: "Auction terms",
      reserveLabel: "Reserve price",
      minIncrementLabel: "Minimum bid increment",
      durationLabel: "Duration",
      antiSnipeLabel: "Anti-snipe window",
      dur1h: "1 hour",
      dur6h: "6 hours",
      dur24h: "24 hours",
      dur3d: "3 days",
      dur7d: "7 days",
      antiSnipe60: "60 seconds",
      antiSnipe300: "5 minutes",
      antiSnipeOff: "Off",
      createAuctionBtn: "Create auction",
      creatingAuction: "Creating auction…",
      auctionWalletConfirm: "Confirm auction in your wallet…",
      auctionSubmitting: "Creating auction on-chain…",
      auctionCreatedTitle: "Auction created",
      auctionCreatedBody: "Your auction is live on-chain. Bidders can place bids until it ends.",
      review: "Review",
      reviewArtwork: "Artwork",
      reviewRoyalty: "Royalty",
      reviewMode: "Mode",
      reviewPrice: "Price",
      reviewReserve: "Reserve",
      reviewIncrement: "Increment",
      reviewEnds: "Ends",
      settleAuction: "Settle auction",
      settling: "Settling…",
      settleWalletConfirm: "Confirm settlement in your wallet…",
      settled: "Auction settled",
      cancelAuction: "Cancel auction",
      cancellingAuction: "Cancelling…",
      auctionCancelled: "Auction cancelled.",
      bidPlacedOnchain: "Bid placed on-chain.",
      bidApprove: "Approve USDC in your wallet…",
      bidApproving: "Approving USDC…",
      bidWalletConfirm: "Confirm bid in your wallet…",
      bidSubmitting: "Placing bid on-chain…",
      historyTitle: "History / Provenance",
      historyEmpty: "No sale or auction history yet for this artwork.",
      histPrepared: "Settlement prepared",
      histFinalized: "Sold (fixed price)",
      histAuctionSettled: "Auction settled",
      histFrozen: "Frozen & placed",
      myArtworkListings: "My Artwork Listings",
      noArtworkListings: "No artwork listings",
      noArtworkListingsHint: "List a frozen artwork for sale to see it here.",
      myAuctions: "My Auctions",
      noMyAuctions: "No auctions",
      noMyAuctionsHint: "Create an auction from an artwork you own to see it here.",
      close: "Close",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      done: "Done",
      viewTx: "View tx →",
      signInFirst: "Connect your wallet & sign in →",
      auctionEnds: "Ends {when}",
    },
    demoGrid: {
      title: "Grid Preview Demo",
      subtitle: "Seu terreno demo · substrate de preview isolado",
      disclosure: "Esta é uma superfície PREVIEW DEMO isolada — não a Grid canônica. Nada aqui toca parcels reais, propriedade on-chain ou Base Sepolia.",
      empty: "Você não tem terreno demo nesta preview.",
      emptyHint: "Faça login com a wallet demo do vendedor para ver terreno demo vendável.",
      returnToMarket: "← Voltar ao Marketplace",
      ownedBadge: "Seus",
      listedBadge: "{n} à venda",
      clickToSell: "Clique num parcel para vender uma parte",
      worldLabel: "Mundo 1000 × 1000",
      loadError: "Não foi possível carregar seu terreno demo",
    },
    clock: {
      closing: "encerrando",
      ended: "Encerrada",
    },
    grid: {
      cellAria: "célula {x},{y}",
      cellLockedAria: "célula {x},{y} (bloqueada)",
    },
  },
  purchase: {
    intro: "Prévia de cotação ao vivo — nada é cobrado até você confirmar.",
    loading: "carregando…",
    bootstrapError: "Falha ao carregar /sale/config ou /sale/status: {error}",
    recovery: {
      confirming: "Compra pendente recuperada — confirmando na Base…",
      syncing: "Confirmado on-chain — sincronizando com a Grid…",
      failed: "A transação de compra recuperada foi revertida. Nenhuma parcela foi comprada.",
      degraded: "Rede temporariamente indisponível — tentando novamente o status da compra…",
    },
    sections: {
      contracts: "Contratos on-chain",
      saleStatus: "Status da venda",
      wallet: "Wallet",
      financial: "Saldo e autorização USDC",
      approval: "Autorização USDC",
      purchase: "Compra",
      indexing: "Indexação",
      quote: "Cotação",
    },
    gate: { yes: "SIM", no: "NÃO ({reason})" },
    wallet: {
      connect: "Conectar {name}",
      disconnect: "Desconectar",
      wrongChain: "A wallet está na chain {chainId}, a venda está na {expectedChainId}. Troque de rede na sua wallet.",
      switching: "Trocando…",
      switchTo: "Trocar para a chain {chainId}",
      switchRejected: "troca recusada",
      switchError: "erro de troca: {message}",
    },
    financial: {
      blocked: "leituras desativadas: {reason}",
      readError: "erro de leitura",
      noSellableQuote: "— (nenhuma cotação vendável)",
      insufficient: "insufficient_balance (faltam {amount})",
      approval: "approval_required (necessários {amount})",
      ready: "ready_for_purchase",
      rpcError: "Erro de RPC ao ler o estado do USDC.",
      refetch: "Recarregar saldo/autorização",
    },
    approve: {
      blocked: "autorização desativada: {reason}",
      waitingWallet: "Aguardando a wallet…",
      submitting: "Enviando…",
      confirming: "Confirmando…",
      cta: "Autorizar USDC exatos",
      rejected: "O usuário recusou a transação de autorização. Você pode tentar novamente.",
      reverted: "A transação de autorização foi revertida on-chain.",
      error: "Erro de autorização: {error}",
      confirmed: "Autorização confirmada. Recarga da autorização e nova cotação forçada disparadas.",
    },
    tx: {
      blocked: "compra desativada: {reason}",
      refreshingQuote: "Atualizando a cotação final…",
      awaitingWallet: "Confirme na sua wallet…",
      submitted: "Enviado…",
      confirming: "Confirmando na Base…",
      cta: "Comprar",
      rejected: "O usuário recusou a transação de compra.",
      reverted: "Transação revertida",
      revertedReason: "Transação revertida: {reason}",
      error: "Erro de compra: {error}",
      confirmed: "Transação confirmada on-chain. Sincronizando com a Grid — aguardando a indexação do backend…",
    },
    indexing: {
      pending: "Sincronizando com a Grid…",
      delayed: "Transação confirmada on-chain. A indexação do backend está demorando mais que o esperado.",
      checkAgain: "Verificar novamente",
      success: "Em posse · Live. Compra indexada com sucesso.",
      buyAnother: "Comprar outra parcela",
      anomaly: "Anomalia de indexação detectada ({reason}). A transação on-chain está confirmada, mas o registro indexado não corresponde ao snapshot de compra original. Entre em contato com o suporte com o hash da transação abaixo.",
    },
    quote: {
      empty: "Desenhe um retângulo na grade para obter uma cotação.",
      clearSelection: "Limpar seleção",
      occupiedSelf: "Esta área se sobrepõe a uma parcela que você já possui. Terreno já cunhado não pode ser comprado novamente.",
      occupiedOther: "Esta área se sobrepõe a terreno de propriedade de outra wallet. Desenhe sobre grade livre para comprar.",
      occupiedGeneric: "Esta área se sobrepõe a parcelas existentes e não pode ser comprada. Desenhe sobre grade livre.",
      loading: "carregando cotação…",
    },
    errors: {
      tooWide: "Seleção muito larga — uma única parcela pode ter no máximo 250 células de largura. Desenhe uma área mais estreita.",
      tooHigh: "Seleção muito alta — uma única parcela pode ter no máximo 250 células de altura. Desenhe uma área mais baixa.",
      areaExceeds: "Seleção muito grande — uma única parcela pode cobrir no máximo 10.000 slots (células){yours}. Desenhe uma área menor para obter uma cotação.",
      areaExceedsYours: " — a sua tem {slots} slots",
      outOfBounds: "A seleção ultrapassa a borda da Grid. Mantenha-a totalmente dentro do território 1000 × 1000.",
      zeroOrNegative: "A seleção está vazia — desenhe um retângulo com pelo menos uma célula de largura.",
      vipCap: "Esta área VIP excede o limite comercial por parcela. Desenhe uma área menor.",
      zoneCap: "Esta área excede a capacidade restante da sua zona. Desenhe uma área menor.",
      unexpected: "Erro inesperado.",
    },
  },
  profile: {
    badge: { none: "Ainda sem selo" },
    cockpit: {
      title: "Visão geral",
      available: "Disponível",
      pendingFunding: "Financiamento pendente",
      ownedParcels: "Parcelas em posse",
      influence: "Influência",
      lifetimePts: "pontos totais",
      slots: "{n} slots",
      progressTo: "Progresso até {badge}",
      max: "máx",
      referralCode: "Código de indicação",
      qualified: "{n} qualificadas",
      pending: "{n} pendentes",
    },
    myGrid: {
      loading: "Carregando a sua grade…",
      signIn: "Entrar",
      unavailable: "Indisponível.",
      failedToLoad: "Falha ao carregar",
      retry: "Tentar novamente",
      title: "Minha Grid",
      empty: "Você ainda não possui nenhum terreno. Adquira uma parcela para começar a ganhar recompensas de Vizinhança e Influência.",
      parcels: "Parcelas",
      totalSlots: "Slots totais",
      clusters: "Clusters",
      largestCluster: "Maior cluster",
      slots: "{n} slots",
      parcelMeta: "{w}×{h} · {area} slots",
      edgeNeighbors: "{n} vizinhos de borda",
    },
    influence: {
      title: "Pontuação de Influência",
      lifetimePrivate: "Pontos totais · privado",
      ptsTo: "{points} pts para ",
      maxReached: "Selo máximo alcançado",
      nextAt: "próximo em {threshold}",
      publicNote: "As superfícies públicas mostram apenas o seu selo — nunca a sua pontuação exata. Sem ranking.",
    },
    analytics: {
      title: "Análises",
      retry: "Tentar novamente",
      loadError: "Não foi possível carregar suas análises.",
      sections: { land: "Terreno e posse", creator: "Criador e indicações", trends: "Tendências", rewards: "Recompensas e Influência" },
      kpi: {
        parcelsOwned: "Parcelas em posse",
        totalArea: "Área total",
        primaryAcq: "Aquisições primárias",
        acqVolume: "Volume de aquisição",
        ownedTerritories: "Territórios em posse",
        publishedTerritories: "Territórios publicados",
        createdArtworks: "Obras criadas",
        qualifiedReferrals: "Indicações qualificadas",
        influence: "Influência",
        rewardsAvailable: "Recompensas disponíveis",
        totalRewards: "Recompensas totais",
        pendingFunding: "Financiamento pendente",
      },
      cells: "células",
      referralQ: "Qualificações de indicação",
      inRange: "{n} no período",
      noReferrals: "Ainda não há indicações qualificadas neste período.",
      rewardsByType: "Recompensas por tipo",
      influenceGrowth: "Crescimento da influência",
      noInfluence: "Ainda não há influência neste período.",
      notLiveTitle: "Recompensas e Influência ainda não estão ativas.",
      notLiveBody: "Estas métricas são preenchidas automaticamente quando o programa The Grid Rewards entrar no ar. Nada é rastreado ou estimado até lá.",
    },
    activity: {
      title: "Atividade",
      markAll: "Marcar tudo como lido ({n})",
      filters: { all: "Todos", rewards: "Recompensas", land: "Terreno", artwork: "Obras", account: "Conta" },
      loadError: "Não foi possível carregar sua atividade.",
      retry: "Tentar novamente",
      empty: "Ainda não há atividade. Eventos relevantes na sua Grid aparecerão aqui.",
      loading: "Carregando…",
      loadMore: "Carregar mais",
    },
    rewards: {
      loading: "Carregando recompensas…",
      failedToLoad: "Não foi possível carregar as recompensas",
      auth: { note: "Entre para ver seu saldo de Recompensas e seus saques.", cta: "Ir para entrar" },
      unavailable: "Recompensas indisponíveis.",
      retry: "Tentar novamente",
      errors: {
        belowMin: "O valor está abaixo do mínimo de 350 USDC.",
        exceedsAvailable: "O valor excede o seu saldo Disponível.",
        invalidAmount: "Informe um valor válido.",
        unauthenticated: "Sua sessão expirou — entre novamente.",
        failed: "O saque falhou.",
      },
      balance: {
        title: "Saldo de Recompensas",
        available: "Disponível",
        pendingFunding: "Financiamento pendente",
        awaitingVault: "Aguardando financiamento do Vault",
        withdrawalPending: "Saque pendente",
        withdrawn: "Sacado",
        expired: "Expirado",
        expiryDeadline: "Prazo de expiração",
        forfeits: "O Disponível é perdido se não for reivindicado",
        noTimer: "Nenhum temporizador ativo",
      },
      withdraw: {
        title: "Sacar",
        disabledNote: "Você precisa de pelo menos {min} Disponível para sacar. Disponível atual: {available}.",
        amountLabel: "Valor (USDC)",
        gasLabel: "Estimativa de gas de rede (USDC · opcional)",
        allToggle: "Sacar todo o Disponível ({available})",
        serviceFee: "Taxa de serviço · 2%",
        gasSeparate: "Gas (separado)",
        estimatedNet: "Líquido estimado",
        minNote: "Mínimo {min} bruto. Aplica-se uma taxa de serviço de 2%; o gas de rede é cobrado separadamente e é apenas uma estimativa.",
        belowMin: "Abaixo do mínimo de 350 USDC.",
        exceeds: "Excede o seu saldo Disponível.",
        submitting: "Enviando…",
        submit: "Sacar",
        all: "Sacar tudo",
        success: "Saque solicitado — líquido {net} (taxa {fee}, gas {gas}).",
      },
      payout: {
        title: "Precisa de ajuda para liquidar?",
        body: "Avise a equipe para processar seu saldo Disponível ({available}). Isso não cria dinheiro e nunca ignora a ordem de financiamento.",
        reachTitle: "Alcance {min} em lucros Disponíveis para solicitar um pagamento",
        sending: "Enviando…",
        cta: "Solicitar pagamento",
        minHint: "Alcance {min} em lucros Disponíveis para solicitar um pagamento — você tem {available}.",
        alreadyOpen: "Já há uma solicitação de pagamento aberta.",
        sent: "Solicitação de pagamento enviada à equipe.",
        failed: "Não foi possível enviar a solicitação.",
      },
      history: {
        title: "Histórico de Recompensas",
        empty: "Ainda não há recompensas. As recompensas de Indicação (7%) e Vizinhança (3%) aparecem aqui conforme o terreno é adquirido.",
        referralProv: "Indicação · {pct}% de {gross}",
        neighborProvEdge: "Vizinhança · {edge}/{total} de borda de um pool de {pct}%",
        neighborProvPool: "Vizinhança · pool de {pct}%",
        funded: "Financiado",
        pendingFunding: "Financiamento pendente",
        parcels: "parcelas {ids}",
      },
      withdrawals: {
        title: "Saques",
        pending: "Pendente",
        withdrawn: "Sacado",
        failed: "Falhou",
        net: "{net} líquido",
        gross: "bruto {x}",
        fee: "taxa {x}",
        gas: "gas {x}",
        failureReason: "· {reason} — devolvido ao Disponível para nova tentativa",
      },
    },
  },
  dashboard: {
    publishability: { published: "Publicado", publishable: "Publicável", notPublishable: "Não publicável" },
    territory: { fallback: "Território {ordinal}" },
    route: {
      title: "Meus territórios",
      subtitle: "Centro de comando do proprietário · derivado da sua propriedade real na Grade",
      backToGrid: "Voltar à Grade",
      authTitle: "Autenticação necessária",
      authBody: "Entre com sua carteira para gerenciar seus territórios. Conectar uma carteira não é suficiente — uma sessão assinada é necessária.",
      signIn: "Entrar com Ethereum",
      detailEmpty: "Selecione um território para ver seu resumo de gerenciamento.",
    },
    list: {
      resolving: "Resolvendo seus territórios…",
      unavailableTitle: "Territórios indisponíveis",
      unavailableBody: "Seus dados completos de propriedade não puderam ser resolvidos agora. Nada parcial é mostrado. Tente novamente em breve.",
      emptyTitle: "Ainda não há territórios",
      emptyBody: "Você ainda não possui nenhuma propriedade na Grade.",
      exploreGrid: "Explorar a Grade",
    },
    card: {
      area: "Área",
      gpCapacity: "Capacidade GP",
      propertyUnits: "Unidades de propriedade",
      minNote: "Mínimo de 400 u² para publicar.",
      unreadTitle: "Um administrador enviou uma mensagem de moderação",
      unreadAria: "Mensagem de moderação não lida",
    },
    detail: {
      territoryArea: "Área do território",
      gpCapacity: "Capacidade GP",
      propertyUnits: "Unidades de propriedade",
      underlyingUnitIds: "IDs das unidades subjacentes",
      location: "Localização (limites do mundo)",
      minNote: "Este território está abaixo do mínimo de 400 u² exigido para publicar.",
    },
    identity: {
      title: "Identidade do território",
      rev: "rev {n}",
      authRequired: "Uma sessão assinada é necessária para gerenciar a identidade deste território.",
      unavailable: "O gerenciamento de identidade está disponível apenas para um território legitimamente possuído.",
      loading: "Resolvendo o território atual…",
      namePlaceholder: "Nome de exibição — nomeie este território",
      saved: "Salvo.",
      saving: "Salvando…",
      saveName: "Salvar nome",
      editCanvas: "Editar canvas →",
      saveErrors: {
        STALE_TERRITORY: "Seu território mudou desde que foi carregado. Ele foi atualizado — revise e salve novamente.",
        IDENTITY_VERSION_CONFLICT: "Esta identidade foi atualizada em outro lugar. Ela foi atualizada — revise e salve novamente.",
        IDENTITY_RECONCILIATION_REQUIRED: "Este território agora se funde com outro território nomeado. A reconciliação é necessária antes de salvar.",
        TERRITORY_NOT_PUBLISHABLE: "Este território está abaixo do mínimo de 400 u² exigido para publicar.",
        TERRITORY_NOT_IDENTITY_ELIGIBLE: "O gerenciamento de identidade está disponível apenas para um território legitimamente possuído.",
        DISPLAY_NAME_INVALID: "Esse nome não é permitido.",
        UNTRUSTED_ORIGIN: "Esta solicitação foi bloqueada por segurança. Recarregue a página e tente novamente.",
        CSRF_REQUIRED: "Seu token de segurança estava ausente. Recarregue a página e tente novamente.",
        CSRF_INVALID: "Seu token de segurança expirou. Recarregue a página e tente novamente.",
        CSRF_FETCH_FAILED: "Não foi possível verificar sua sessão. Recarregue a página e tente novamente.",
        UNAUTHENTICATED: "Sua sessão expirou. Entre novamente para salvar.",
        UNSUPPORTED_MEDIA_TYPE: "Algo deu errado ao enviar sua solicitação. Recarregue e tente novamente.",
        SEED_NOT_OWNED: "Você não possui mais este território.",
      },
    },
    reconciliation: {
      intro: "Este território agora funde {n} territórios nomeados em um só. Escolha qual identidade sobrevive — as outras são substituídas. Os nomes não são mesclados.",
      metaOne: "{n} unidade · rev {rev}",
      metaOther: "{n} unidades · rev {rev}",
      reconciling: "Reconciliando…",
      confirmSurvivor: "Confirmar sobrevivente",
      errors: {
        STALE_TERRITORY: "Seu território mudou desde que foi carregado. Ele foi atualizado — revise e escolha novamente.",
        IDENTITY_VERSION_CONFLICT: "Uma dessas identidades mudou em outro lugar. Ela foi atualizada — revise e escolha novamente.",
        RECONCILIATION_NOT_REQUIRED: "Este território não precisa mais de reconciliação. Ele foi atualizado.",
        SURVIVOR_NOT_CANDIDATE: "Essa identidade não é mais elegível. Ela foi atualizada.",
        TERRITORY_NOT_PUBLISHABLE: "Este território está abaixo do mínimo de 400 u² exigido para publicar.",
        UNTRUSTED_ORIGIN: "Esta solicitação foi bloqueada por segurança. Recarregue a página e tente novamente.",
        CSRF_REQUIRED: "Seu token de segurança estava ausente. Recarregue a página e tente novamente.",
        CSRF_INVALID: "Seu token de segurança expirou. Recarregue a página e tente novamente.",
        CSRF_FETCH_FAILED: "Não foi possível verificar sua sessão. Recarregue a página e tente novamente.",
        UNAUTHENTICATED: "Sua sessão expirou. Entre novamente.",
        TRANSACTION_UNAVAILABLE: "O serviço está brevemente indisponível. Tente novamente em instantes.",
        SEED_NOT_OWNED: "Você não possui mais este território.",
      },
    },
    brandImage: {
      title: "Imagem da marca · LOD0",
      rev: "rev {n}",
      desc: "Imagem de mapa opcional para este território (PNG · JPEG · WebP, ≤ 5 MiB, ≤ 2048px). Grátis.",
      recommendedPrefix: "Recomendado para o seu território:",
      size: "{rw} × {rh} px",
      ratioNote: "(proporção {ratio}) — corresponde à sua parcela para que o logotipo não fique esticado.",
      previewAlt: "Imagem da marca do território",
      unsaved: "Pré-visualização não salva — pressione Salvar para mantê-la.",
      empty: "Ainda não há imagem da marca.",
      saved: "Salvo.",
      removed: "Imagem da marca removida.",
      authRequired: "Uma sessão assinada é necessária para gerenciar a imagem da marca.",
      chooseAria: "Escolha uma imagem da marca",
      replace: "Substituir…",
      select: "Selecionar imagem…",
      saving: "Salvando…",
      save: "Salvar",
      cancel: "Cancelar",
      remove: "Remover",
      removeConfirm: "Remover a imagem da marca?",
      removing: "Removendo…",
      confirm: "Confirmar",
      keep: "Manter",
    },
    publish: {
      publishing: "Publicando…",
      republish: "Republicar",
      published: "Publicado",
      publish: "Publicar",
      blockedSave: "Salve seu rascunho antes de publicar",
      stateLabels: {
        UNPUBLISHED: "Não publicado",
        PUBLISHED_CURRENT: "Publicado · atual",
        DRAFT_CHANGED: "Publicado · rascunho alterado",
        TERRITORY_CHANGED: "Publicado · território alterado",
      },
    },
    media: {
      fileTooLarge: "O arquivo é maior que o máximo de 250 MiB.",
      title: "Biblioteca de mídia",
      subtitle: "Mídia reutilizável da sua carteira · Imagem 10 · GIF 20 (10s) · PDF 25 · Vídeo 250 MiB · Biblioteca 2 GiB",
      working: "Processando…",
      upload: "Enviar",
      used: "{x} usados",
      free: "{free} livres de {total}",
      loading: "Carregando biblioteca…",
      empty: "Ainda não há mídia. Envie uma imagem, GIF, PDF ou vídeo para iniciar sua biblioteca.",
      loadMore: "Carregar mais",
      pages: "{n} páginas",
      deleteAria: "Excluir recurso",
    },
  },
  artist: {
    utility: {
      loading: "Carregando utilidade da parcela…",
      referral: {
        title: "Indicação",
        yourCode: "Seu código de indicação",
        copyLink: "Copiar link de indicação",
        copied: "Copiado",
        qualified: "Indicações qualificadas",
        pending: "Indicações pendentes",
        empty: "Ainda não há indicações. Compartilhe seu link — uma indicação se qualifica quando seu convidado faz sua primeira aquisição de terra primária.",
        preparing: "Seu código de indicação está sendo preparado a partir da propriedade canônica — volte em breve.",
        ownToUnlock: "Possua pelo menos uma parcela para desbloquear seu código de indicação.",
        wasReferred: "Você foi indicado · status",
      },
      parcel: {
        title: "Utilidade da parcela",
        empty: "Atualmente você não possui nenhuma parcela. Adquira terra para desbloquear a utilidade da parcela.",
        parcels: "Parcelas",
        totalArea: "Área total",
        clusters: "Clusters",
        largestCluster: "Maior cluster",
        flagBasicIdentity: "Identidade básica",
        flagPublishable: "Publicável",
        flagPublished: "Publicado",
        flagHasNeighbors: "Tem vizinhos",
        neighbors: "{n} vizinhos",
        cluster: "cluster {size} · {area} u²",
      },
      neighborhood: {
        title: "Vizinhança",
        empty: "Possua uma parcela para ver sua vizinhança.",
        edgeNeighbors: "Vizinhos de borda",
        connectedClusters: "Clusters conectados",
        connectedClusterLabel: "Cluster conectado",
        clusterSummary: "{size} parcelas · {area} u²",
        openParcel: "Parcela #{id} — {n} vizinho(s) de borda",
        loading: "Carregando…",
        noEdgeNeighbors: "Sem vizinhos de borda.",
        yours: "seu",
        published: "publicado",
      },
    },
    profile: {
      loading: "Carregando perfil…",
      connectWallet: "Conecte sua carteira",
      connectBody: "Entre para ver seu perfil de Artista, elegibilidade e Capacidade Criativa.",
      goToSignIn: "Ir para entrar",
      unavailable: "Perfil indisponível.",
      retry: "Tentar novamente",
      loadFail: "Falha ao carregar o perfil",
      moderationLabel: "Moderação",
      moderationMsg: "Mensagem do admin",
      moderationAria: "Você tem uma mensagem de um administrador — abra Meus territórios para lê-la",
      tabs: { overview: "Visão geral", rewards: "Recompensas", activity: "Atividade", analytics: "Análises", grid: "Minha Grade" },
      roleTitle: "Função",
      roleArtist: "Você é um Artista — uma identidade permanente conquistada por elegibilidade de terra e tempo de posse.",
      roleNeo: "Você é um NeoArtista — uma identidade permanente com acesso acelerado à criação de Artista quando elegível. Mesmas capacidades criativas de um Artista.",
      roleCreator: "Atualmente você possui terra, então pode usar as ferramentas criativas. Criador é um estado atual — acompanha sua posse de terra e não é um selo permanente.",
      roleUser: "Atualmente você não possui terra e não desbloqueou uma identidade artística permanente. Adquira terra para se tornar um Criador, ou alcance 50% de elegibilidade para o caminho NeoArtista.",
      statusCurrentState: "· estado atual",
      eligTitle: "Elegibilidade de Artista",
      neoThreshold: "Limiar NeoArtista · 50%",
      artistThreshold: "Limiar Artista · 100%",
      eligUnits: "{units} / {total} unidades de elegibilidade",
      tierSlots: "{slots} slots · {units}u",
      tenureTitle: "Tempo de posse de Artista · 100 dias",
      tenureBlock: " (bloco {block})",
      tenurePending: "Primeira aquisição de terra registrada on-chain{block}. A data exata está sendo resolvida a partir de dados canônicos da cadeia — o tempo de posse será exibido quando disponível. Nenhuma data é mostrada até que possa ser comprovada.",
      firstAcq: "Primeira aquisição: {date}",
      daysLine: "{days} / {min} dias",
      reqMet: "requisito atendido",
      daysRemaining: "{n} dias restantes",
      ccTitle: "Capacidade Criativa",
      ccTotal: "Total",
      ccUsed: "Usada",
      ccAvailable: "Disponível",
      ccNote: "A capacidade vem da terra que você possui e permanece vinculada ao histórico de cada parcela.",
      neoTitle: "Caminho NeoArtista",
      neoHavePermanent: "Você já possui uma identidade permanente {status}.",
      neoNeedElig: "Alcance 50% de Elegibilidade de Artista para desbloquear o caminho NeoArtista acelerado (atualmente {pct}%).",
      neoEligibleBody: "Você é elegível para o caminho NeoArtista acelerado (taxa única, em USDC ou USDT). NeoArtista não concede Capacidade Criativa extra.",
      neoFee: "Taxa: {fee} · {currencies}",
      neoFeeNotConfigured: "Taxa ainda não configurada — nenhum preço é mostrado até que The Grid a defina.",
      neoPaymentPending: "Integração de pagamento pendente",
      collectionTitle: "Coleção",
      collCreatedBy: "Criado por",
      collOwned: "Possuído",
      collCreatedCount: "{n} criados",
      collCreatedEmpty: "Ainda não há obras congeladas.",
      collOwnedEmpty: "Nenhuma obra atualmente possuída.",
      editTitle: "Editar perfil",
      editDisplayName: "Nome de exibição",
      editBio: "Bio",
      editAvatar: "URL do avatar (https/ipfs)",
      editSaving: "Salvando…",
      editSave: "Salvar",
      editSaved: "Salvo",
      editSaveFail: "Falha ao salvar",
    },
  },
  social: {
    follow: { follow: "Seguir", following: "Seguindo", actionFailed: "Ação falhou" },
    report: {
      moreOptions: "Mais opções",
      reason: "Motivo",
      report: "Denunciar",
      blockUser: "Bloquear usuário",
      reported: "Denunciado. Obrigado.",
      reportFailed: "Falha na denúncia",
      blocked: "Bloqueado.",
      blockFailed: "Falha ao bloquear",
      reasons: {
        spam: "Spam", abuse: "Abuso", harassment: "Assédio", hate: "Ódio",
        nsfw: "NSFW", scam: "Golpe", impersonation: "Falsidade ideológica", other: "Outro",
      },
    },
    bar: {
      save: "Salvar", saved: "Salvo", comments: "Comentários",
      likeError: "Não foi possível atualizar a curtida", saveError: "Não foi possível atualizar o salvamento",
    },
    comment: {
      post: "Publicar", postError: "Não foi possível publicar", removed: "[removido]", you: "você",
      reply: "Responder", hide: "Ocultar", viewOne: "Ver {n} resposta", viewMany: "Ver {n} respostas",
      delete: "Excluir", loadingReplies: "Carregando respostas…", replyPlaceholder: "Escreva uma resposta…",
      heading: "Comentários", topPlaceholder: "Compartilhe suas ideias sobre este Território…",
      signin: "Entre para participar da conversa →", loading: "Carregando comentários…",
      empty: "Ainda não há comentários. Seja o primeiro.", loadingMore: "Carregando…", loadMore: "Carregar mais",
    },
    creator: {
      signinPre: "Entre", signinPost: "para ver seu perfil.",
      none: "Nenhum criador especificado.", loading: "Carregando perfil…", unavailable: "Perfil indisponível.",
      followers: "Seguidores", following: "Seguindo", likes: "Curtidas", comments: "Comentários",
      territories: "Territórios", published: "Publicados",
      gotoFeed: "Ir para o seu feed →", recentActivity: "Atividade recente",
    },
    feed: {
      title: "Social", yourProfile: "Seu perfil →",
      following: "Seguindo", discover: "Descobrir",
      followingSignin: "Entre para ver os criadores que você segue →",
      loading: "Carregando feed…", unavailable: "Feed indisponível.",
      emptyFollowing: "Seu feed está quieto. Siga criadores para ver aqui seus Territórios e obras mais recentes.",
      emptyDiscover: "Nada para descobrir ainda — novos Territórios publicados aparecem aqui.",
      loadingMore: "Carregando…", loadMore: "Carregar mais",
      titlePublication: "Publicou um Território",
      titleArtworkNamed: "Publicou a obra “{title}”",
      titleArtwork: "Publicou uma obra",
      titleAcquiredParcel: "Adquiriu a parcela #{id}",
      titleAcquired: "Adquiriu um novo Território",
    },
    handle: {
      heading: "Seu perfil social", handleLabel: "Identificador", handlePlaceholder: "seu_identificador",
      save: "Salvar", handleSaved: "Identificador salvo.", handleError: "Não foi possível salvar o identificador",
      handleHint: "3–24 caracteres · letras, dígitos, sublinhado · alterável a cada 30 dias.",
      linksLabel: "Links", linkLabelPlaceholder: "Rótulo", addLink: "+ Adicionar link",
      saveLinks: "Salvar links", linksSaved: "Links salvos.", linksError: "Não foi possível salvar os links",
    },
  },
  legal: {
    navAria: "Navegação de documentos legais",
  },
  editor: {
    pixel: {
      title: "Pixel Studio",
      deleteTitle: "Excluir este pixel art",
      delete: "Excluir",
      closeTitle: "Fechar o estúdio",
      startingPoint: "Ponto de partida",
      startingPointBody: "Transformamos sua imagem em pixels para lhe dar uma base. Agora torne-a sua…",
      pencil: "Lápis", eraser: "Borracha", fill: "Preencher", pick: "Conta-gotas",
      undo: "Desfazer", redo: "Refazer", clear: "Limpar", grid: "Grade",
      importOpen: "Importar imagem → Pixel",
      brush: "Pincel", zoom: "Zoom",
      zoomOutTitle: "Zoom − (células menores)", zoomInTitle: "Zoom + (células maiores)",
      cellsPainted: "Células pintadas:",
      paletteActive: "Paleta ativa", paletteActiveNote: "· imagem importada / desenho",
      add: "+ Adicionar", recent: "Recentes",
      paletteBase: "Paleta base", paletteBaseNote: "· cores padrão THE GRID",
      saving: "Salvando…", saveArtworkCanvas: "Salvar obra + canvas",
      unsaved: "Não salvo", saved: "Salvo", close: "Fechar",
      pixelizeTitle: "Pixelizar imagem", cancel: "Cancelar",
      resultingGrid: "Grade resultante:", colorsLabel: "cores:",
      resolution: "Resolução (lado longo)", fitMode: "Ajuste",
      fitContain: "Conter", fitCover: "Preencher", maxColors: "Cores máx.",
      dithering: "Dithering", on: "ON", off: "OFF",
      alphaThreshold: "Limite de transparência ({v})", useAsBase: "Usar como base",
      unsavedTitle: "Alterações não salvas",
      unsavedBody: "Você tem alterações de pixel art ainda não salvas no canvas. O que você quer fazer?",
      saveAndClose: "Salvar e fechar", discardClose: "Fechar sem salvar",
    },
    voxel: {
      invalid: "Rota do editor 3D inválida.",
      authRequired: "Entre com sua carteira para editar esta cena 3D.",
      signIn: "Entrar →",
      loading: "Carregando editor 3D…",
      back: "Voltar",
      empty: "Nenhum território.",
      failedToLoad: "Falha ao carregar",
      noFootprint: "Este território não tem parcelas próprias para construir.",
      flashCreateFirst: "Crie ou selecione uma Obra primeiro",
      flashOutside: "Fora da sua área possuída",
      flashCleared: "Peça ativa esvaziada",
      flashNoImage: "Não foi possível ler a imagem",
      flashBaseInside: "A base deve permanecer dentro do seu território",
      canvas: "Canvas",
      add: "Adicionar", remove: "Remover", cancelBase: "Cancelar base",
      currentColorTitle: "Cor atual (altere-a na barra lateral)",
      undo: "Desfazer", undoTitle: "Desfazer (Ctrl+Z)",
      redo: "Refazer", redoTitle: "Refazer (Ctrl+Shift+Z)",
      clear: "Limpar", clearTitle: "Esvaziar a peça ativa",
      resetView: "Redefinir visão",
      saving: "Salvando…", saved: "Salvo", save: "Salvar",
      saveTitle: "Salvar rascunho 3D", saveOverTitle: "Acima da capacidade — remova voxels para salvar",
      publishTitle: "A publicação acontece no Canvas — inclui automaticamente esta cena 3D salva",
      publishLink: "Publicar no Canvas →",
      reload: "Recarregar",
      color: "Cor", customColorTitle: "Cor personalizada",
      workArts: "Obras", newBase: "+ Nova base",
      budgetLabel: "Orçamento:", cellsUnit: "células",
      noWorkArts: "Ainda não há obras.",
      activePiece: "Peça ativa", rotate: "Girar", rotationHint: "Redefina a rotação para 0° para editar voxels.",
      imageToVoxel: "Imagem → Voxel", depth: "Profundidade", converting: "Convertendo…", chooseImage: "Escolher imagem…",
      conversionHelp: "A conversão ajuda você a começar com uma extrusão simples. Você pode refinar o resultado voxel por voxel.",
      fallback: "A edição 3D precisa de WebGL, que este dispositivo não conseguiu iniciar. Seu rascunho 3D está seguro — tente um navegador de desktop com aceleração de hardware.",
      defineTitle: "Definir base — arraste na grade",
      defineBody: "Arraste um retângulo no chão para dimensionar sua peça, depois solte para criá-la.",
      sizeLabel: "Tamanho", tooBig: "· grande demais",
      noCapacityTitle: "Sem capacidade 3D livre",
      noCapacityBody: "Você ainda não pode colocar blocos neste território. O presente 3D gratuito (10.000+ voxels) é concedido apenas à carteira que comprou uma parcela na venda primária e ainda a possui. Parcelas que foram reivindicadas/cunhadas ou compradas de segunda mão não recebem nenhum.",
      hintNewBase: "Clique em “+ Nova base”, depois arraste na grade para dimensionar sua peça.",
      howToBuild: "Como construir",
      step1: "Clique + Nova base, depois arraste na grade para dimensionar a peça",
      step2: "Clique esquerdo no chão / na face de um bloco para colocar blocos",
      step3: "Clique direito em um bloco para removê-lo",
      mouse: "Mouse", showControls: "Mostrar controles e como construir", hide: "Ocultar",
      leftClick: "Clique esquerdo", rightClick: "Clique direito", ctrlLeft: "Ctrl + esquerdo", ctrlRight: "Ctrl + direito", scroll: "Rolagem",
      drawBase: "Desenhar base", placeBlock: "Colocar bloco", removeBlock: "Remover bloco", orbit: "Orbitar ao redor do clique", pan: "Mover a visão", zoomInOut: "Aproximar / afastar",
      capacity3d: "Capacidade 3D", overCapacity: "Acima da capacidade",
    },
    templates: {
      title: "Modelos de Canvas",
      curatedStarts: "6 pontos de partida selecionados",
      close: "Fechar modelos",
      apply: "Aplicar modelo",
      previewAria: "Pré-visualização do layout de {name}",
      replaceTitle: "Substituir o rascunho atual?",
      replaceBody: "Aplicar {name} substituirá o conteúdo do seu rascunho atual ({count} {unit}). Seu território publicado não é afetado até você salvar e publicar. Esta ação só pode ser desfeita com Desfazer.",
      elementOne: "elemento",
      elementOther: "elementos",
      cancel: "Cancelar",
      replaceDraft: "Substituir rascunho",
      catalog: {
        creator: { name: "Criador / Marca pessoal", useCase: "Identidade pessoal", tagline: "Uma identidade ousada e centralizada — nome, papel, bio, redes e uma única chamada para ação.", tag0: "Identidade", tag1: "Bio", tag2: "Redes" },
        retail: { name: "Varejo / Vitrine", useCase: "Marca pequena e loja", tagline: "Um cabeçalho de marca sobre uma prateleira de produtos rítmica, com uma ação clara de visitar-loja.", tag0: "Produtos", tag1: "Prateleira", tag2: "Link da loja" },
        gallery: { name: "Artista / Galeria", useCase: "A obra em primeiro lugar", tagline: "Um único quadro dominante com uma declaração sóbria — a obra guia, as palavras seguem.", tag0: "Obra", tag1: "Declaração", tag2: "Minimal" },
        music: { name: "Música / Evento", useCase: "Lançamento e evento ao vivo", tagline: "Título cheio de energia, data e local, e uma ação direta de ingressos / streaming.", tag0: "Evento", tag1: "Data", tag2: "Ingressos" },
        product: { name: "Produto / Lançamento tech", useCase: "Landing de lançamento", tagline: "Uma página de lançamento moderna — título, linha de apoio, três blocos de recursos e um CTA.", tag0: "Lançamento", tag1: "Recursos", tag2: "CTA" },
        minimal: { name: "Luxo minimalista", useCase: "Minimalismo sofisticado", tagline: "Tipografia contida e espaço generoso — uma palavra, uma linha, uma ação.", tag0: "Luxo", tag1: "Espaço em branco", tag2: "Contenção" },
      },
    },
    error: {
      title: "O canvas encontrou um erro",
      body: "O editor se recuperou em vez de ficar preto. As alterações não salvas desde o seu último salvamento não foram gravadas no servidor. Tente dispensar para continuar, ou recarregue o editor para um estado limpo.",
      dismiss: "Dispensar",
      reload: "Recarregar editor",
    },
    canvas: {
      invalid: "Rota de canvas inválida.",
      authRequired: "Entre com sua wallet para editar este Canvas.",
      signIn: "Entrar →",
      loading: "Carregando o Canvas…",
      empty: "Nenhum canvas.",
      failedToLoad: "Falha ao carregar",
      back: "Voltar",
      close: "Fechar",
      cancel: "Cancelar",
      exitConfirm: "Você tem alterações não salvas. Sair sem salvar?",
      flash: {
        saved3d: "Posição 3D salva",
        territoryChanged3d: "Território alterado — recarregue o editor",
        error3d: "3D: {code}",
        rotateOutside: "A rotação sairia do território",
      },
      save: {
        territoryChanged: "Território alterado — recarregar o editor",
      },
      toolbar: {
        territories: "Territórios",
        undo: "Desfazer",
        redo: "Refazer",
        fit: "Ajustar território",
        templates: "Modelos",
        templatesTitle: "Comece a partir de um modelo premium",
        templatesDisabledTitle: "Modelos exigem um território próprio",
        mediaLibrary: "Biblioteca de mídia",
        mediaLibraryTitle: "Biblioteca de mídia — envie e navegue sem sair do editor",
        artistProfile: "Perfil do artista",
        artistProfileTitle: "Abra seu perfil de artista",
        editor3d: "Editor 3D",
        editor3dTitle: "Abra o editor de voxel 3D para este território",
        save: "Salvar",
        saving: "Salvando…",
        saveTitle: "Salvar canvas",
        saveOverTitle: "Capacidade excedida — reduza o uso de GP para salvar",
        freeze: "Congelar",
        freezeTitle: "Congele esta obra do Pixel Studio",
        freezeBlockedTitle: "Salve o canvas antes de congelar",
      },
      tools: {
        pixelArt: "Pixel Art",
        new: "NOVO",
        text: "Texto",
        interactive: "Interativo",
        media: "Mídia",
        shapes: "Formas",
      },
      pixelDraw: {
        banner: "Desenhe um retângulo no seu território",
      },
      pixelSize: {
        title: "Nova Pixel Art",
        body: "Escolha um tamanho de canvas — 1 célula = 1 parcela. Células vazias permanecem transparentes.",
        custom: "Personalizado — desenhe no território",
      },
      mobileReadonly: "Somente leitura / inspeção neste dispositivo. A edição requer uma tela maior.",
      gp: {
        used: "Usados",
        available: "Disponíveis {n} GP",
        overCapacity: "Capacidade excedida",
      },
      status: {
        saved: "Salvo",
        unsavedChanges: "Alterações não salvas",
        saving: "Salvando…",
        error: "Erro",
        showError: "Mostrar o erro completo",
      },
      inspector: {
        territoryTiers: "Níveis do território",
        globalStyle: "Estilo global",
        background: "Fundo",
        bgColor: "Cor de fundo",
        perimeter: "Perímetro",
        perimeterGlow: "Brilho do perímetro",
        opacity: "Opacidade {v}%",
        glow: "Brilho",
        glowColor: "Cor do brilho",
        text: "Texto",
        label: "Rótulo",
        subtitleOptional: "Subtítulo (opcional)",
        urlHttps: "URL (https)",
        previewOpen: "Pré-visualizar / Abrir ↗",
        fill: "Preenchimento",
        lineColor: "Cor da linha",
        fit: "Ajuste",
        pixelArt: "Pixel Art",
        editPixels: "Editar pixels",
        title: "Título",
        bgPreview: "Pré-visualização do fundo",
        changeImage: "Alterar imagem",
        addImage: "+ Adicionar imagem",
        selectedGp: "GP {used} / {max} máx",
      },
      controls: {
        preset: "Predefinição",
        layout: "Layout",
        direction: "Direção",
        columns: "Colunas {v}",
        align: "Alinhamento",
        gap: "Espaçamento {v}",
        iconSize: "Tamanho do ícone {v}",
        labelOptional: "Rótulo (opcional)",
        labelColor: "Cor do rótulo",
        brandColors: "Cores da marca",
        iconColor: "Cor do ícone",
        backgroundChip: "Chip de fundo",
        bgColor: "Cor de fundo",
        border: "Borda",
        borderColor: "Cor da borda",
        radius: "Raio",
        padding: "Preenchimento {v}",
        hover: "Hover",
        font: "Fonte",
        color: "Cor",
        textSize: "Tamanho do texto {v}",
        style: "Estilo",
        subtitleColor: "Cor do subtítulo",
        underline: "Sublinhar rótulo",
        icon: "Ícone",
      },
      social: {
        links: "Links ({n}/5)",
        removeLink: "Remover link",
        addLink: "+ Adicionar link",
        showLabels: "Mostrar rótulos",
        labelFont: "Fonte do rótulo",
        labelSize: "Tamanho do rótulo {v}",
      },
      contacts: {
        heading: "Contatos ({n}/10)",
        removeContact: "Remover contato",
        addContact: "+ Adicionar contato",
        show: "Mostrar",
        value: "Valor",
        dataColor: "Cor dos dados",
        kind: { EMAIL: "E-mail", PHONE: "Telefone", WHATSAPP: "WhatsApp", WEBSITE: "Site", MAP: "Endereço" },
        placeholder: { EMAIL: "nome@exemplo.com", PHONE: "+55 11 90000-1234", WHATSAPP: "+55 11 90000-1234", WEBSITE: "https://exemplo.com", MAP: "Rua Principal 1, Cidade" },
      },
      layers: {
        title: "Camadas",
        empty: "Ainda não há módulos.",
        front: "Para frente",
        forward: "Avançar",
        backward: "Recuar",
        back: "Para trás",
        hide: "Ocultar",
        lock: "Bloquear",
      },
      mediaPanel: {
        title: "Biblioteca de mídia",
        working: "Processando…",
        upload: "Enviar",
        hint: "Imagem 10 · GIF 20 (10s) · PDF 25 · Vídeo 250 MiB · Biblioteca 2 GiB. Os envios aparecem instantaneamente nos seletores Adicionar mídia.",
        loading: "Carregando biblioteca…",
        empty: "Ainda não há mídia. Envie uma imagem, GIF, PDF ou vídeo para começar sua biblioteca.",
        loadMore: "Carregar mais",
        deleteAria: "Excluir asset",
      },
      mediaPicker: {
        choose: "Escolher {kind} da biblioteca de mídia",
        empty: "Nenhum asset de {kind}. Envie primeiro na biblioteca de mídia do painel.",
      },
      mediaKind: { image: "imagem", gif: "GIF", video: "vídeo", pdf: "PDF" },
      errorModal: {
        saveFailed: "Falha ao salvar",
        gotIt: "Entendi",
      },
      tier: { STANDARD: "Standard", PREMIUM: "Premium", VIP_CORE: "VIP Core", RESERVE: "Reserva", GRID_ZERO: "GRID ZERO" },
      enum: {
        module: { TITLE: "Título", TAGLINE: "Slogan", DESCRIPTION: "Descrição", LINK: "Link", SOCIAL: "Social", CONTACTS: "Contatos", IMAGE: "Imagem", GIF: "GIF", VIDEO: "Vídeo", PDF: "PDF", PIXEL_ART: "Pixel Art", SHAPE: "Forma" },
        shape: { RECTANGLE: "Retângulo", ROUNDED_RECTANGLE: "Retângulo arredondado", ELLIPSE: "Elipse", LINE: "Linha" },
        bgMode: { NEUTRAL: "Neutro", SOLID_COLOR: "Cor sólida" },
        glow: { OFF: "Desligado", LOW: "Baixo", MEDIUM: "Médio", HIGH: "Alto" },
        direction: { HORIZONTAL: "Horizontal", VERTICAL: "Vertical", GRID: "Grade" },
        align: { START: "Início", CENTER: "Centro", END: "Fim" },
        textAlign: { LEFT: "Esquerda", CENTER: "Centro", RIGHT: "Direita", JUSTIFY: "Justificado" },
        radius: { SQUARE: "Quadrado", SLIGHT: "Leve", ROUNDED: "Arredondado", PILL: "Pílula" },
        hover: { NONE: "Nenhum", LIFT: "Elevar", GLOW: "Brilho", SCALE: "Escala" },
        fit: { COVER: "Preencher", CONTAIN: "Ajustar" },
        contactsDisplay: { ICON: "Ícone", ICON_LABEL: "Ícone + rótulo", ICON_DATA: "Ícone + dados", BUTTON: "Botão" },
        linkIcon: { NONE: "Nenhum", ARROW: "Seta", FAVICON: "Favicon" },
        socialPreset: { ICONS_ONLY: "Somente ícones", MINIMAL: "Minimal", BUTTONS: "Botões", CARDS: "Cartões" },
        contactsPreset: { ICONS_ONLY: "Somente ícones", BUSINESS: "Negócios", MINIMAL: "Minimal" },
        linkPreset: { TEXT: "Texto", BUTTON: "Botão", OUTLINE: "Contorno", CARD: "Cartão" },
      },
    },
  },
};

export default ptBr;
